import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  Long: { input: number; output: number; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: string; output: string; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  UUID: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: File; output: File; }
  /** Represents NULL values */
  Void: { input: null; output: null; }
};

export type Account = {
  accountType: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['NonEmptyString']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<AccountPreferences>;
  profileUrl?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<AccountSocialLinks>;
};

export type AccountPreferences = {
  __typename?: 'AccountPreferences';
  /** Yes, I would like Kijiji and its corporate family members to contact me about events, new features, and other promotional information. */
  contactMe: Scalars['Boolean']['output'];
  /** Hide the visit counter on my ads (Only you will be able to see the visits number using My Ads). */
  hideVisit: Scalars['Boolean']['output'];
  /** Send me Bump Up and other feature notification emails. */
  pushNotification: Scalars['Boolean']['output'];
  /** Read Receipts enabled (others will see when I've read their messages). */
  readReciepts: Scalars['Boolean']['output'];
};

export type AccountSocialLinks = {
  __typename?: 'AccountSocialLinks';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type Ad = MoveAd | OrganicAd;

export type AdCommon = {
  categoryId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Price>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdData = {
  __typename?: 'AdData';
  adId: Scalars['ID']['output'];
};

export type AdDataPair = {
  __typename?: 'AdDataPair';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AdFeedbackSource {
  MarkAsSold = 'MARK_AS_SOLD',
  MyKijiji = 'MY_KIJIJI',
  Svip = 'SVIP'
}

export type AdLocation = {
  __typename?: 'AdLocation';
  distance?: Maybe<Scalars['Float']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export enum AdSource {
  Cas = 'CAS',
  Move = 'MOVE',
  Organic = 'ORGANIC',
  ProvTopAd = 'PROV_TOP_AD',
  TopAd = 'TOP_AD',
  VerticalAutos = 'VERTICAL_AUTOS'
}

export enum AdSourceType {
  A = 'A',
  C = 'C',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Z = 'Z'
}

export enum AdType {
  None = 'NONE',
  Offer = 'OFFER',
  Wanted = 'WANTED'
}

export enum AdditionalFlags {
  Carproof = 'CARPROOF',
  CategorySpecificBadge = 'CATEGORY_SPECIFIC_BADGE',
  Cpo = 'CPO',
  FinancingAvailable = 'FINANCING_AVAILABLE',
  Gallery = 'GALLERY',
  Highlight = 'HIGHLIGHT',
  Images = 'IMAGES',
  PriceDrop = 'PRICE_DROP',
  TopAd = 'TOP_AD',
  VeteranFriendly = 'VETERAN_FRIENDLY',
  Videos = 'VIDEOS',
  VirtualTour = 'VIRTUAL_TOUR'
}

export type AdditionalFlagsFilterInput = {
  filterName: Scalars['String']['input'];
  flags: Array<AdditionalFlags>;
};

export type AddressFormat = {
  __typename?: 'AddressFormat';
  long: Scalars['String']['output'];
  short: Scalars['String']['output'];
};

export type AmountPrice = {
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  originalAmount?: Maybe<Scalars['Float']['output']>;
  type: ListingPriceType;
};

export type AppliedAdditionalFlagsFilter = AppliedFilter & {
  __typename?: 'AppliedAdditionalFlagsFilter';
  filterName: Scalars['String']['output'];
  flags: Array<AdditionalFlags>;
};

export type AppliedAttributeFilter = AppliedFilter & {
  __typename?: 'AppliedAttributeFilter';
  filterName: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type AppliedDateFilter = AppliedFilter & {
  __typename?: 'AppliedDateFilter';
  filterName: Scalars['String']['output'];
  value: Scalars['Date']['output'];
};

export type AppliedDateRangeFilter = AppliedFilter & {
  __typename?: 'AppliedDateRangeFilter';
  end?: Maybe<Scalars['Date']['output']>;
  filterName: Scalars['String']['output'];
  start?: Maybe<Scalars['Date']['output']>;
};

export type AppliedFilter = {
  filterName: Scalars['String']['output'];
};

export type AppliedRangeFilter = AppliedFilter & {
  __typename?: 'AppliedRangeFilter';
  filterName: Scalars['String']['output'];
  maxValue?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Int']['output']>;
};

export type AppliedToggleFilter = AppliedFilter & {
  __typename?: 'AppliedToggleFilter';
  filterName: Scalars['String']['output'];
  toggleValue: Scalars['String']['output'];
};

/** Shared Inputs */
export type AreaLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  /** Radius should be in kilometres */
  radius: Scalars['Int']['input'];
};

export type Attribute = {
  __typename?: 'Attribute';
  canonicalName?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  controlRange?: Maybe<IntegerRange>;
  controlType?: Maybe<ControlType>;
  id: Scalars['Int']['output'];
  isBoolean?: Maybe<Scalars['Boolean']['output']>;
  localizedFields?: Maybe<Array<Maybe<AttributeFields>>>;
  localizedNames?: Maybe<AttributeNames>;
  required: Scalars['Boolean']['output'];
};


export type AttributeLocalizedFieldsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type AttributeLocalizedNamesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeFields = {
  __typename?: 'AttributeFields';
  canonicalValue?: Maybe<Scalars['String']['output']>;
  seoSlug?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Schema for Tree Select, Checkbox, Multi-Select, and Toggles Controls */
export type AttributeFilter = Filter & {
  __typename?: 'AttributeFilter';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  selectedValues?: Maybe<Array<Scalars['String']['output']>>;
  type: FilterControlType;
  values?: Maybe<Array<AttributeValue>>;
};

export type AttributeFilterInput = {
  filterName: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type AttributeInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeMap = {
  __typename?: 'AttributeMap';
  carbodytype_s?: Maybe<Scalars['String']['output']>;
  carcolor_s?: Maybe<Scalars['String']['output']>;
  carfueltype_s?: Maybe<Scalars['String']['output']>;
  carmake_s?: Maybe<Scalars['String']['output']>;
  carmileageinkms_i?: Maybe<Scalars['String']['output']>;
  carmodel_s?: Maybe<Scalars['String']['output']>;
  cartransmission_s?: Maybe<Scalars['String']['output']>;
  cartrim_s?: Maybe<Scalars['String']['output']>;
  caryear_i?: Maybe<Scalars['String']['output']>;
  drivetrain_s?: Maybe<Scalars['String']['output']>;
  forsaleby_s?: Maybe<Scalars['String']['output']>;
  furnished_s?: Maybe<Scalars['String']['output']>;
  numberbathrooms_s?: Maybe<Scalars['String']['output']>;
  numberbedrooms_s?: Maybe<Scalars['String']['output']>;
  petsallowed_s?: Maybe<Scalars['String']['output']>;
  phonebrand_s?: Maybe<Scalars['String']['output']>;
  phonecarrier_s?: Maybe<Scalars['String']['output']>;
  size_s?: Maybe<Scalars['String']['output']>;
  stock_s?: Maybe<Scalars['String']['output']>;
  unittype_s?: Maybe<Scalars['String']['output']>;
  vehicletype_s?: Maybe<Scalars['String']['output']>;
  vin_s?: Maybe<Scalars['String']['output']>;
};

export type AttributeNames = {
  __typename?: 'AttributeNames';
  groupName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subGroupName?: Maybe<Scalars['String']['output']>;
};

export type AttributeValue = {
  __typename?: 'AttributeValue';
  label: Scalars['String']['output'];
  parentValue?: Maybe<Scalars['String']['output']>;
  /** Only applies to category and location attribute values that have more than 5 results */
  seoUrl?: Maybe<Scalars['URL']['output']>;
  totalResults?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type AuthModalState = {
  __typename?: 'AuthModalState';
  callbackUrl?: Maybe<Scalars['String']['output']>;
  isModalOpen: Scalars['Boolean']['output'];
  modalVariant?: Maybe<AuthModalVariant>;
};

export enum AuthModalVariant {
  LoginToFavourite = 'LOGIN_TO_FAVOURITE'
}

export type AutosDealerAmountPrice = AmountPrice & ListingPrice & {
  __typename?: 'AutosDealerAmountPrice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  msrp?: Maybe<Scalars['Float']['output']>;
  originalAmount?: Maybe<Scalars['Float']['output']>;
  surcharges: AutosSurcharges;
  type: ListingPriceType;
};

export type AutosListing = FullListing & Listing & {
  __typename?: 'AutosListing';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  /** Autos Listing fields */
  attributes: AutosListingAttributes;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  flags: AutosListingFlags;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocation;
  mileageAnalysis?: Maybe<MileageAnalysis>;
  moveUrl?: Maybe<Scalars['URL']['output']>;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  views?: Maybe<Scalars['Int']['output']>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type AutosListingAttributes = ListingAttributes & {
  __typename?: 'AutosListingAttributes';
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  /** Listing attributes that only apply to Autos categories */
  carfaxUrl?: Maybe<Scalars['URL']['output']>;
  cpoProgram?: Maybe<Scalars['Boolean']['output']>;
  forSaleBy?: Maybe<Scalars['String']['output']>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type AutosListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AutosListingFlags = ListingFlags & {
  __typename?: 'AutosListingFlags';
  /** Listing flags that only apply to Autos categories */
  carfaxAvailable?: Maybe<Scalars['Boolean']['output']>;
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  chatOptIn?: Maybe<Scalars['Boolean']['output']>;
  financingAvailable?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  provTopAd?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
};

export enum AutosSurcharges {
  NoTax = 'NO_TAX',
  PlusGst = 'PLUS_GST',
  PlusTaxes = 'PLUS_TAXES',
  PlusTaxesLuxurySurcharge = 'PLUS_TAXES_LUXURY_SURCHARGE'
}

export type AveragePrice = {
  __typename?: 'AveragePrice';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type BackgroundAdType = {
  __typename?: 'BackgroundAdType';
  color?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type BackgroundType = {
  __typename?: 'BackgroundType';
  altText?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type BaseListing = {
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price?: Maybe<Price>;
  title: Scalars['String']['output'];
};

export enum BlendingPattern {
  Largest = 'LARGEST',
  Repeat = 'REPEAT'
}

export type BoxFields = {
  __typename?: 'BoxFields';
  kjses?: Maybe<Scalars['String']['output']>;
  xsrfToken?: Maybe<Scalars['String']['output']>;
};

export type BrandedCategoryItem = {
  __typename?: 'BrandedCategoryItem';
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  seoUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BrowseHeroModule = {
  __typename?: 'BrowseHeroModule';
  component: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  tiles: Array<Maybe<BrowseTile>>;
  title: Array<Maybe<CustomizedText>>;
};

export type BrowseTile = {
  __typename?: 'BrowseTile';
  background?: Maybe<BackgroundType>;
  link: LinkType;
  title: Scalars['String']['output'];
  tracking?: Maybe<Tracking>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Cta = {
  __typename?: 'CTA';
  altText?: Maybe<Scalars['String']['output']>;
  link: LinkType;
  text: Scalars['String']['output'];
  tracking?: Maybe<Tracking>;
};

export type Campaign = {
  __typename?: 'Campaign';
  customFields?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Category = {
  __typename?: 'Category';
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  categoryPath?: Maybe<Scalars['String']['output']>;
  categoryPaths?: Maybe<Array<Maybe<Category>>>;
  children?: Maybe<Array<Maybe<Category>>>;
  enabled?: Maybe<CategoryEnabled>;
  id: Scalars['Int']['output'];
  isRoot?: Maybe<Scalars['Boolean']['output']>;
  isVacationRentals?: Maybe<Scalars['Boolean']['output']>;
  l1Category?: Maybe<Category>;
  localizedName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  searchSeoUrl?: Maybe<Scalars['String']['output']>;
};


export type CategoryAttributesArgs = {
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  isProfessionalUser?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<PageType>;
};


export type CategoryChildrenArgs = {
  filterDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CategoryLocalizedNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type CategorySearchSeoUrlArgs = {
  keywords?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryEnabled = {
  __typename?: 'CategoryEnabled';
  browsing?: Maybe<Scalars['Boolean']['output']>;
  posting?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryLink = {
  __typename?: 'CategoryLink';
  nameId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CategoryLinkInfo = {
  categoryId: Scalars['Int']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  nameId: Scalars['String']['input'];
};

export type ClientSelectionDetail = {
  __typename?: 'ClientSelectionDetail';
  conversationId: Scalars['String']['output'];
  lastMessage: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  receivedDate: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

/** Deprecated: Use CommercialProfileV2 instead */
export type CommercialProfile = {
  __typename?: 'CommercialProfile';
  address?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  /** @deprecated Use searchResultsLogoUrl, viewAdLogoUrl, merchantStoreLogoUrl instead */
  logo?: Maybe<Scalars['String']['output']>;
  memberSince?: Maybe<Scalars['Long']['output']>;
  merchantStoreLogoUrl?: Maybe<Scalars['String']['output']>;
  numberOfOrganicAds?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  searchResultsLogoUrl?: Maybe<Scalars['String']['output']>;
  staticMapUrl?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  viewAdLogoUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CommercialProfileV2 = ProfileV2 & {
  __typename?: 'CommercialProfileV2';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listings?: Maybe<Array<FullListing>>;
  logoUrl?: Maybe<Scalars['URL']['output']>;
  name: Scalars['String']['output'];
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  staticMapUrl?: Maybe<Scalars['URL']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  userType: UserType;
  websiteUrl?: Maybe<Scalars['URL']['output']>;
};


export type CommercialProfileV2ListingsArgs = {
  pagination: PaginationInputV2;
  sort: ProfileSortInput;
};


export type CommercialProfileV2LogoUrlArgs = {
  size: LogoType;
};


export type CommercialProfileV2PhoneNumberArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ContactType {
  New = 'NEW',
  Used = 'USED'
}

export type ContentModule = BrowseHeroModule;

export enum ContentModuleId {
  WelcomePopularBanner = 'WELCOME_POPULAR_BANNER'
}

export enum ControlType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Dropdown = 'DROPDOWN',
  IntegerRange = 'INTEGER_RANGE',
  MakeModel = 'MAKE_MODEL',
  String = 'STRING'
}

export type Conversation = {
  __typename?: 'Conversation';
  adId: Scalars['String']['output'];
  creationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  messageNotification?: Maybe<Scalars['String']['output']>;
  participants?: Maybe<Array<Maybe<Participant>>>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ConversationId = {
  __typename?: 'ConversationId';
  id?: Maybe<Scalars['String']['output']>;
};

export type CoreListing = Listing & {
  __typename?: 'CoreListing';
  adSource: AdSource;
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocation;
  price?: Maybe<ListingPrice>;
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type CovidResponse = {
  __typename?: 'CovidResponse';
  badges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dealerId?: Maybe<Scalars['Int']['output']>;
  dealerMessage?: Maybe<Scalars['String']['output']>;
  dealerWebsiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomizedText = {
  __typename?: 'CustomizedText';
  style?: Maybe<CustomizedTextStyle>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomizedTextStyle = {
  __typename?: 'CustomizedTextStyle';
  color?: Maybe<Scalars['String']['output']>;
  isBold?: Maybe<Scalars['Boolean']['output']>;
};

/** Schema for Single Date Filters */
export type DateFilter = Filter & {
  __typename?: 'DateFilter';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  selectedValue?: Maybe<Scalars['Date']['output']>;
  type: FilterControlType;
};

export type DateFilterInput = {
  filterName: Scalars['String']['input'];
  value: Scalars['Date']['input'];
};

export type DateRangeFilterInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  filterName: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type DeleteAdInputArgs = {
  adId: Scalars['Int']['input'];
  surveyEventInput?: InputMaybe<DeleteSurveyEventInput>;
};

export type DeleteSurveyEventInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientUserId?: InputMaybe<Scalars['Int']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  feedbackSource?: InputMaybe<AdFeedbackSource>;
  platform: Scalars['String']['input'];
  questions?: InputMaybe<Array<InputMaybe<SurveyQuestionInput>>>;
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  triggerType?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<SurveyUserInput>;
};

export type Details = {
  billingToken?: InputMaybe<Scalars['String']['input']>;
  facilitatorAccessToken?: InputMaybe<Scalars['String']['input']>;
  orderID?: InputMaybe<Scalars['ID']['input']>;
  payerID?: InputMaybe<Scalars['ID']['input']>;
  paymentID?: InputMaybe<Scalars['ID']['input']>;
};

export enum Direction {
  B2S = 'B2S',
  Both = 'BOTH',
  S2B = 'S2B'
}

export type DismissedStates = {
  __typename?: 'DismissedStates';
  appDownloadPSA: Scalars['Boolean']['output'];
  siteMaintenancePSA_may7th: Scalars['Boolean']['output'];
};

export type DropInConfiguration = {
  __typename?: 'DropInConfiguration';
  clientKey: Scalars['String']['output'];
  environment: DropInEnvironment;
  paymentMethods: Scalars['String']['output'];
  paypalMerchantId: Scalars['String']['output'];
};

export enum DropInEnvironment {
  Live = 'LIVE',
  Test = 'TEST'
}

export type DynamicPhoneNumber = {
  __typename?: 'DynamicPhoneNumber';
  e164?: Maybe<Scalars['String']['output']>;
  local?: Maybe<Scalars['String']['output']>;
};

export type EasyPriceDropNotification = Notification & {
  __typename?: 'EasyPriceDropNotification';
  body: Scalars['String']['output'];
  data: AdData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EditAdPriceResponse = {
  __typename?: 'EditAdPriceResponse';
  status?: Maybe<EditAdPriceStatus>;
};

export type EditAdPriceStatus = {
  __typename?: 'EditAdPriceStatus';
  message?: Maybe<RepostAdStatus>;
  statusCode: Scalars['Int']['output'];
};

/** URL types for tracking events */
export enum EventsUrlType {
  PartnerPage = 'PARTNER_PAGE',
  SellerHomepage = 'SELLER_HOMEPAGE',
  SellerProductPage = 'SELLER_PRODUCT_PAGE'
}

export type ExternalListingSource = {
  __typename?: 'ExternalListingSource';
  sourceAdId?: Maybe<Scalars['String']['output']>;
  sourcePartnerId?: Maybe<Scalars['String']['output']>;
  sourceProviderId?: Maybe<Scalars['String']['output']>;
};

export type Favourite = {
  adSource: AdSourceType;
  id: Scalars['Int']['input'];
};

export type FavouriteEntry = {
  __typename?: 'FavouriteEntry';
  adSource: AdSourceType;
  id: Scalars['Long']['output'];
};

export type FavouriteListing = {
  __typename?: 'FavouriteListing';
  adSource: AdSourceType;
  categoryId: Scalars['Int']['output'];
  creationDate: Scalars['String']['output'];
  favouriteDate: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  image?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Long']['output']>;
  priceType?: Maybe<PriceType>;
  title: Scalars['String']['output'];
};

export type FavouriteSearchActivateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notificationDetails: NotificationDetailsInput;
  /**
   * searchQuery will be formatted the same way it is for searchResultsPageUpdate
   * using parseInputQueryParams, as https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/postsavedsearch
   * is expecting it in the same format as that used by the v2/listings endpoint
   */
  searchString: Scalars['String']['input'];
};

export type FavouriteSearchAlert = {
  __typename?: 'FavouriteSearchAlert';
  address?: Maybe<Scalars['String']['output']>;
  alertDestinations: Array<Maybe<FavouriteSearchAlertDestinations>>;
  alertId: Scalars['Int']['output'];
  category?: Maybe<Category>;
  creationDate: Scalars['String']['output'];
  keywords?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  radius?: Maybe<Scalars['Int']['output']>;
  seoUrl: Scalars['String']['output'];
};

export type FavouriteSearchAlertDestinations = {
  __typename?: 'FavouriteSearchAlertDestinations';
  active: Scalars['Boolean']['output'];
  destination: Scalars['String']['output'];
  destinationType: Scalars['String']['output'];
  frequency?: Maybe<Scalars['Int']['output']>;
};

export type FavouriteSearchIdLookupInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /**
   * searchQuery will be formatted the same way it is for searchResultsPageUpdate
   * using parseInputQueryParams, as https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/postsavedsearch
   * is expecting it in the same format as that used by the v2/listings endpoint
   */
  searchString: Scalars['String']['input'];
};

export type FavouriteSearchIdLookupOutput = {
  __typename?: 'FavouriteSearchIdLookupOutput';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type FeedItem = BaseListing & {
  __typename?: 'FeedItem';
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price: Price;
  processorName?: Maybe<Scalars['String']['output']>;
  seoUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type FeedPageInfo = {
  __typename?: 'FeedPageInfo';
  currentPage?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAds?: Maybe<Scalars['Int']['output']>;
};

export type FeedRecommendations = {
  __typename?: 'FeedRecommendations';
  adSource?: Maybe<Scalars['String']['output']>;
  ads?: Maybe<Array<Maybe<FeedItem>>>;
  description: Scalars['String']['output'];
  seedId: Scalars['Int']['output'];
  seedType?: Maybe<Scalars['String']['output']>;
  seoUrl: Scalars['String']['output'];
};

export type FeedRecommendationsInput = {
  correlationId?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationPath?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationLimitOffset>;
  processor: RecommendationProcessor;
  userId: Scalars['Int']['input'];
};

export type FeedResults = BrandedCategoryItem | FeedItem | PopularCategoryItem;

export type FeedbackOption = {
  __typename?: 'FeedbackOption';
  contradictFeedbackId?: Maybe<Scalars['Int']['output']>;
  direction: Direction;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: FeedbackType;
};

export type FeedbackSummaryItem = {
  __typename?: 'FeedbackSummaryItem';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum FeedbackType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type Filter = {
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  type: FilterControlType;
};

export enum FilterControlType {
  Checkboxes = 'CHECKBOXES',
  Date = 'DATE',
  DateRange = 'DATE_RANGE',
  /**
   * The HAS_FILTERS are used by the SRP to filter listings based on specific attributes that are not tied to the category post ad flow in which the listing is posted.
   * For example, filters like “Ads with images” or “Ads with videos.”
   * Internally, the HAS_FILTERS values represent AdditionalFlags. Unlike other filters, their schema is different due to the nature of the data incoming from the backend.
   * Instead of using objects to relate to which filter name is applied, AdditionalFlags are just represented as a simple array of strings that only represents the values.
   */
  HasFilters = 'HAS_FILTERS',
  MultiSelect = 'MULTI_SELECT',
  Radio = 'RADIO',
  Range = 'RANGE',
  Toggles = 'TOGGLES',
  TreeSelect = 'TREE_SELECT',
  Unknown = 'UNKNOWN'
}

export type FilterGroup = {
  __typename?: 'FilterGroup';
  filters: Array<Filter>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** At the time of its implementation, this field is only used to determine the order of the quick filter pills in the SRP */
  quickFilterSortOrder?: Maybe<Scalars['Int']['output']>;
  shouldShowTopLevelAccordion?: Maybe<Scalars['Boolean']['output']>;
};

export enum FilterPriceType {
  Contact = 'CONTACT',
  Fixed = 'FIXED',
  GiveAway = 'GIVE_AWAY',
  SwapTrade = 'SWAP_TRADE'
}

export type FullListing = {
  /** Full Listing fields */
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  attributes?: Maybe<ListingAttributes>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  flags: ListingFlags;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocation;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  /** The date used to sort on SRP (handles bump-ups) */
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  views?: Maybe<Scalars['Int']['output']>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type GalleryItem = {
  __typename?: 'GalleryItem';
  /** @deprecated Flag is no longer provided by backend */
  featured: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  imageAltText?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  price?: Maybe<Price>;
  /** @deprecated Flag is no longer provided by backend */
  reduced: Scalars['Boolean']['output'];
  seoUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urgent: Scalars['Boolean']['output'];
};

export type GenerateXsrfResponse = {
  __typename?: 'GenerateXsrfResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  xsrf: Scalars['String']['output'];
};

export type GeocodeCanadianAddress = {
  __typename?: 'GeocodeCanadianAddress';
  city?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LocationCoordinates>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
};

export type GeocodeReverseFromIp = {
  __typename?: 'GeocodeReverseFromIp';
  city?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  province: ProvinceAbbreviation;
};

export type GeolocationInput = {
  accuracy: Scalars['Int']['input'];
  altitude?: InputMaybe<Scalars['Int']['input']>;
  altitudeAccuracy?: InputMaybe<Scalars['Int']['input']>;
  heading?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Int']['input'];
  longitude: Scalars['Int']['input'];
  speed?: InputMaybe<Scalars['Int']['input']>;
  timestamp: Scalars['Int']['input'];
};

export type GetAllFavouriteSearchPaging = {
  __typename?: 'GetAllFavouriteSearchPaging';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type GetAllFavouriteSearchResponse = {
  __typename?: 'GetAllFavouriteSearchResponse';
  alerts: Array<Maybe<FavouriteSearchAlert>>;
  paging: GetAllFavouriteSearchPaging;
};

export type GoogleAuthor = {
  __typename?: 'GoogleAuthor';
  name: Scalars['String']['output'];
  profilePhotoUrl?: Maybe<Scalars['URL']['output']>;
  profileUrl?: Maybe<Scalars['URL']['output']>;
};

export type GoogleReview = {
  __typename?: 'GoogleReview';
  author: GoogleAuthor;
  rating: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTime']['output'];
};

export type GoogleReviews = {
  __typename?: 'GoogleReviews';
  rating: Scalars['Float']['output'];
  reviews: Array<GoogleReview>;
  totalCount: Scalars['Int']['output'];
  url: Scalars['URL']['output'];
};

export enum Hints {
  CovidAttributesReJobs = 'COVID_ATTRIBUTES_RE_JOBS',
  GoogleMapsDetailsFlow = 'GOOGLE_MAPS_DETAILS_FLOW'
}

export type HomeFeed = {
  __typename?: 'HomeFeed';
  pageInfo?: Maybe<FeedPageInfo>;
  results?: Maybe<Array<Maybe<FeedResults>>>;
};

export type HomeFeedAds = {
  __typename?: 'HomeFeedAds';
  adSlots?: Maybe<Scalars['Int']['output']>;
};

export type HomeFeedInput = {
  cid?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  location?: InputMaybe<LocationQueryCoordsOptions>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['Int']['input'];
};

export type HomepageGallery = {
  __typename?: 'HomepageGallery';
  items?: Maybe<Array<Maybe<GalleryItem>>>;
  seeAllLink: Scalars['String']['output'];
};

export type Image = {
  __typename?: 'Image';
  imageAltText?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type IntegerRange = {
  __typename?: 'IntegerRange';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export enum ItemSearchHints {
  DominantCategory = 'DOMINANT_CATEGORY',
  IndexCategoryNames = 'INDEX_CATEGORY_NAMES',
  IndexTags = 'INDEX_TAGS'
}

export type ItemSearchOptions = {
  blend?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  excludeAdId?: InputMaybe<Scalars['Int']['input']>;
  externalSourceProviderId?: InputMaybe<Scalars['Int']['input']>;
  hasFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hints?: InputMaybe<Array<InputMaybe<ItemSearchHints>>>;
  ip?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  likeText?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<RadialLocationInput>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  posterSource?: InputMaybe<PosterSource>;
  price?: InputMaybe<PriceInput>;
  sessionTestGroup?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<AdType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type LpBillboardModule = {
  __typename?: 'LPBillboardModule';
  adUnitId: Scalars['String']['output'];
  background?: Maybe<BackgroundAdType>;
  component: Scalars['String']['output'];
  pos?: Maybe<Scalars['String']['output']>;
  tile?: Maybe<Scalars['Int']['output']>;
};

export type LpBrowseModule = {
  __typename?: 'LPBrowseModule';
  arrangement?: Maybe<TileArrangement>;
  component: Scalars['String']['output'];
  displayFormat?: Maybe<TileDisplayFormat>;
  heading?: Maybe<Array<Maybe<CustomizedText>>>;
  tileStyle?: Maybe<TileStyle>;
  tiles: Array<Maybe<BrowseTile>>;
};

export type LpHeroModule = {
  __typename?: 'LPHeroModule';
  background?: Maybe<BackgroundType>;
  component: Scalars['String']['output'];
  ctas?: Maybe<Array<Maybe<Cta>>>;
  description: Array<Maybe<CustomizedText>>;
  isOverlay?: Maybe<Scalars['Boolean']['output']>;
  partner?: Maybe<Partner>;
  title: Array<Maybe<CustomizedText>>;
};

export type LpLeaderboardModule = {
  __typename?: 'LPLeaderboardModule';
  adUnitId: Scalars['String']['output'];
  background?: Maybe<BackgroundAdType>;
  component: Scalars['String']['output'];
  pos?: Maybe<Scalars['String']['output']>;
  tile?: Maybe<Scalars['Int']['output']>;
};

export type LabeledUrl = {
  __typename?: 'LabeledUrl';
  label: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type LandingPageContent = {
  __typename?: 'LandingPageContent';
  modules: Array<Maybe<LandingPageModule>>;
  title: Scalars['String']['output'];
};

export type LandingPageModule = BrowseHeroModule | LpBillboardModule | LpBrowseModule | LpHeroModule | LpLeaderboardModule;

export type LatLngType = {
  __typename?: 'LatLngType';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LinkType = {
  __typename?: 'LinkType';
  categoryId?: Maybe<Scalars['Int']['output']>;
  isNewTab?: Maybe<Scalars['Boolean']['output']>;
  keyword?: Maybe<Scalars['String']['output']>;
  nameId?: Maybe<Scalars['String']['output']>;
  type: LinkVariant;
  url: Scalars['String']['output'];
};

export enum LinkVariant {
  Paf = 'PAF',
  Srp = 'SRP',
  Url = 'URL',
  /** @deprecated Use URL instead */
  External = 'external',
  /** @deprecated Use URL instead */
  Internal = 'internal'
}

export type Listing = {
  adSource: AdSource;
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocation;
  price?: Maybe<ListingPrice>;
  title: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type ListingAttributeV2 = {
  __typename?: 'ListingAttributeV2';
  canonicalName: Scalars['String']['output'];
  canonicalValues?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  values: Array<Maybe<Scalars['String']['output']>>;
};

export type ListingAttributes = {
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type ListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListingFlags = {
  /** Urgent / Reduced Badge */
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  /** TODO: Look into what these promotion topAds are and if that are category specific */
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
};

/** An estimated (or exact) location of an ad. */
export type ListingLocation = {
  __typename?: 'ListingLocation';
  address?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<LocationCoordinates>;
  distance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nearestIntersection?: Maybe<Array<Scalars['String']['output']>>;
  showPinOnMap?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingPrice = {
  type: ListingPriceType;
};

export enum ListingPriceType {
  Contact = 'CONTACT',
  DriveAway = 'DRIVE_AWAY',
  Fixed = 'FIXED',
  Free = 'FREE',
  GiveAway = 'GIVE_AWAY',
  MakeOffer = 'MAKE_OFFER',
  Monthly = 'MONTHLY',
  SpecifiedAmount = 'SPECIFIED_AMOUNT',
  StandardMonthly = 'STANDARD_MONTHLY',
  SwapTrade = 'SWAP_TRADE'
}

export type Listings = {
  __typename?: 'Listings';
  forCategory?: Maybe<ListingsData>;
  forUser?: Maybe<ListingsData>;
};


export type ListingsForCategoryArgs = {
  attributeFilters?: InputMaybe<Array<InputMaybe<AttributeInput>>>;
  categoryId: Scalars['Int']['input'];
  numberOfAds?: InputMaybe<Scalars['Int']['input']>;
};


export type ListingsForUserArgs = {
  posterSource?: InputMaybe<PosterSource>;
  userId: Scalars['Int']['input'];
};

export type ListingsData = {
  __typename?: 'ListingsData';
  items?: Maybe<Array<Maybe<SrpListing>>>;
  totals: TotalListings;
};

export type LivePersonContextVariable = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LivePersonIDs = {
  __typename?: 'LivePersonIDs';
  botId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type LivePersonVipData = {
  botId: Scalars['ID']['input'];
  contextVariables: Array<LivePersonContextVariable>;
  conversationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type Locale = {
  __typename?: 'Locale';
  en_CA?: Maybe<Scalars['String']['output']>;
  fr_CA?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  coordinates?: Maybe<LocationCoordinates>;
  id: Scalars['Int']['output'];
  localizedName?: Maybe<Scalars['String']['output']>;
  locationPaths?: Maybe<Array<Location>>;
  name?: Maybe<Locale>;
  nameId?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  parentLocation?: Maybe<Location>;
  searchSeoUrl?: Maybe<Scalars['String']['output']>;
  seoLocation?: Maybe<Scalars['String']['output']>;
  siblingLocations: Array<Maybe<Location>>;
};


export type LocationLocalizedNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type LocationArea = {
  __typename?: 'LocationArea';
  address?: Maybe<Scalars['String']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  /** Radius is represented in kilometres */
  radius: Scalars['Int']['output'];
};

export type LocationCoordinates = {
  __typename?: 'LocationCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/**
 * Ideally at some point, we can use @oneOf for LocationInput.
 * https://stepzen.com/blog/coming-soon-to-graphql-the-oneof-input-object
 */
export type LocationInput = {
  area?: InputMaybe<AreaLocationInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationQueryCoordsOptions = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type LocationWithPlace = {
  __typename?: 'LocationWithPlace';
  location?: Maybe<Location>;
  place?: Maybe<PlaceDetails>;
};

export type LoginUserInput = {
  additionalData?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  emailOrNickname: Scalars['String']['input'];
  externalEmail?: InputMaybe<Scalars['String']['input']>;
  externalIdentifier?: InputMaybe<Scalars['String']['input']>;
  fraudToken?: InputMaybe<Scalars['String']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  kjses?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  recaptchaResponse?: InputMaybe<Scalars['String']['input']>;
  rememberMe: Scalars['Boolean']['input'];
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  xsrfToken?: InputMaybe<Scalars['String']['input']>;
};

export type LoginUserResponse = {
  __typename?: 'LoginUserResponse';
  boxToken?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum LogoType {
  MerchantStore = 'MERCHANT_STORE',
  SearchResults = 'SEARCH_RESULTS',
  ViewAd = 'VIEW_AD'
}

export type LogoutUserInput = {
  xsrfToken: Scalars['String']['input'];
};

export type LogoutUserResponse = {
  __typename?: 'LogoutUserResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  categoryId: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  children?: Maybe<Array<Maybe<MenuItem>>>;
  id: Scalars['Int']['output'];
  isLeaf: Scalars['Boolean']['output'];
  seoUrl: Scalars['String']['output'];
};

export type MileageAnalysis = {
  __typename?: 'MileageAnalysis';
  categories: MileageAnalysisCategories;
  usage: MileageAnalysisUsage;
  value: Scalars['Int']['output'];
};

export type MileageAnalysisCategories = {
  __typename?: 'MileageAnalysisCategories';
  average: Scalars['Int']['output'];
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
};

export enum MileageAnalysisUsage {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

/** Shared Schema Types */
export type MinMax = {
  __typename?: 'MinMax';
  max?: Maybe<Scalars['Float']['output']>;
  min: Scalars['Float']['output'];
};

export type MinMaxInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type MoveAd = AdCommon & {
  __typename?: 'MoveAd';
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price?: Maybe<Price>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceAdId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  vehicleReport?: Maybe<VehicleReport>;
};

export type MoveListing = {
  __typename?: 'MoveListing';
  priceRating?: Maybe<MoveListingPriceRating>;
};

export type MoveListingPriceRating = {
  __typename?: 'MoveListingPriceRating';
  rating?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateFavouriteSearch?: Maybe<Scalars['Int']['output']>;
  activateFavouriteSearchGuest?: Maybe<Scalars['Int']['output']>;
  /** Add listing to the user's list of favourites. */
  addFavouriteListing: Scalars['ID']['output'];
  /** @deprecated Use `addFavouriteListing` which calls favourite endpoint through GCP Gateway */
  addFavouriteNew?: Maybe<Scalars['Boolean']['output']>;
  /** Change Password via Email Reset Link */
  changePasswordViaResetLink?: Maybe<Scalars['Void']['output']>;
  clearUnseenCount?: Maybe<StatusResponse>;
  createReview?: Maybe<StatusResponse>;
  deactivateFavouriteSearch?: Maybe<Scalars['Int']['output']>;
  deleteAd?: Maybe<Scalars['Boolean']['output']>;
  deleteNotification?: Maybe<StatusResponse>;
  editAdPrice?: Maybe<EditAdPriceResponse>;
  /** Used to track third party URL clicks from listings */
  eventsExternalClick?: Maybe<Scalars['Void']['output']>;
  /** https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/postsavedsearch */
  favouriteSearchActivate: Scalars['ID']['output'];
  /** https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/deleteSavedSearch */
  favouriteSearchDeactivate?: Maybe<Scalars['Void']['output']>;
  generateXsrf?: Maybe<GenerateXsrfResponse>;
  getAlgoliaKey?: Maybe<Scalars['Boolean']['output']>;
  getGoogleMapsKey?: Maybe<Scalars['Boolean']['output']>;
  getPlaceToken?: Maybe<Scalars['Boolean']['output']>;
  /** Report a listing */
  listingReport?: Maybe<Scalars['Void']['output']>;
  /**
   * Track a visit to a listing
   * @deprecated To be integrated with the listings call
   */
  listingVisit?: Maybe<Scalars['Void']['output']>;
  /** Send data about the current VIP to LivePerson. */
  livePersonSendVipData?: Maybe<Scalars['Void']['output']>;
  loginUser?: Maybe<LoginUserResponse>;
  logoutUser?: Maybe<LogoutUserResponse>;
  markAsRead?: Maybe<StatusResponse>;
  /** Returns ID for successfull one time saved search */
  oneTimeSavedSearch: Scalars['Int']['output'];
  /** Returns ID for successfull one time saved search */
  oneTimeSavedSearchLegacy?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use 'userRegistration()' instead. */
  registerUser?: Maybe<RegisterUserResponse>;
  /** Remove listing from the user's list of favourites. */
  removeFavouriteListing: Scalars['ID']['output'];
  /** @deprecated Use `removeFavouriteListing` which calls favourite endpoint through GCP Gateway */
  removeFavouriteNew?: Maybe<Scalars['Boolean']['output']>;
  removeFavourites?: Maybe<Scalars['String']['output']>;
  removePaymentInfo?: Maybe<Scalars['Boolean']['output']>;
  removeProfileImage?: Maybe<ProfileUpdateResponse>;
  repostAd?: Maybe<RepostAdResponse>;
  /** Reset user password */
  requestPasswordResetLink?: Maybe<Scalars['Void']['output']>;
  submitPayment?: Maybe<SubmitPaymentResponse>;
  submitPaymentDetails?: Maybe<SubmitPaymentResponse>;
  /** Update password */
  updatePassword?: Maybe<StatusResponse>;
  /** Update account information */
  updatePersonalInformation?: Maybe<StatusResponse>;
  /** Update user preferences */
  updatePreferences?: Maybe<StatusResponse>;
  updateProfileImage?: Maybe<ProfileUpdateResponse>;
  /** Update social links */
  updateSocialLinks?: Maybe<StatusResponse>;
  /** Upload a new profile image */
  uploadProfileImage?: Maybe<UploadProfileImageResponse>;
  /** Create a new User account, confirmation email will be sent on success. */
  userRegistration?: Maybe<Scalars['Void']['output']>;
};


export type MutationActivateFavouriteSearchArgs = {
  searchString: Scalars['String']['input'];
};


export type MutationActivateFavouriteSearchGuestArgs = {
  email: Scalars['String']['input'];
  searchString: Scalars['String']['input'];
};


export type MutationAddFavouriteListingArgs = {
  listingId: Scalars['ID']['input'];
};


export type MutationAddFavouriteNewArgs = {
  adSource: AdSourceType;
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationChangePasswordViaResetLinkArgs = {
  password: Scalars['String']['input'];
  token: Scalars['UUID']['input'];
};


export type MutationClearUnseenCountArgs = {
  lastSeenNotificationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationCreateReviewArgs = {
  review?: InputMaybe<ReviewInput>;
};


export type MutationDeactivateFavouriteSearchArgs = {
  alertId: Scalars['Int']['input'];
};


export type MutationDeleteAdArgs = {
  input?: InputMaybe<DeleteAdInputArgs>;
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationEditAdPriceArgs = {
  adId: Scalars['Int']['input'];
  newPrice: Scalars['Long']['input'];
};


export type MutationEventsExternalClickArgs = {
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  urlType: EventsUrlType;
};


export type MutationFavouriteSearchActivateArgs = {
  input: FavouriteSearchActivateInput;
};


export type MutationFavouriteSearchDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationListingReportArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Reason;
};


export type MutationListingVisitArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLivePersonSendVipDataArgs = {
  input: LivePersonVipData;
};


export type MutationLoginUserArgs = {
  input?: InputMaybe<LoginUserInput>;
};


export type MutationLogoutUserArgs = {
  input?: InputMaybe<LogoutUserInput>;
};


export type MutationMarkAsReadArgs = {
  notificationId: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationOneTimeSavedSearchArgs = {
  input: OneTimeSavedSearchInput;
};


export type MutationOneTimeSavedSearchLegacyArgs = {
  input: OneTimeSavedSearchLegacyInput;
};


export type MutationRegisterUserArgs = {
  input?: InputMaybe<RegisterUserInput>;
};


export type MutationRemoveFavouriteListingArgs = {
  listingId: Scalars['ID']['input'];
};


export type MutationRemoveFavouriteNewArgs = {
  adSource: AdSourceType;
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRemoveFavouritesArgs = {
  favourites: Array<InputMaybe<Favourite>>;
  userId: Scalars['Int']['input'];
};


export type MutationRemovePaymentInfoArgs = {
  recurringDetailReference: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
  xsrfToken: Scalars['String']['input'];
};


export type MutationRepostAdArgs = {
  adId: Scalars['Int']['input'];
  xsrfToken: Scalars['String']['input'];
};


export type MutationRequestPasswordResetLinkArgs = {
  input: RequestPasswordResetLinkInput;
};


export type MutationSubmitPaymentArgs = {
  invoiceId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  storePaymentMethod: Scalars['Boolean']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  xsrfToken: Scalars['String']['input'];
};


export type MutationSubmitPaymentDetailsArgs = {
  details: Details;
  invoiceId: Scalars['ID']['input'];
  paymentData: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
  xsrfToken: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdatePersonalInformationArgs = {
  input: UpdatePersonalInformationInput;
};


export type MutationUpdatePreferencesArgs = {
  input: UpdatePreferencesInput;
};


export type MutationUpdateProfileImageArgs = {
  input: ProfileImageInput;
};


export type MutationUpdateSocialLinksArgs = {
  input: UpdateSocialLinksInput;
};


export type MutationUploadProfileImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUserRegistrationArgs = {
  input: UserRegistrationInput;
};

export type NonAmountPrice = ListingPrice & {
  __typename?: 'NonAmountPrice';
  type: ListingPriceType;
};

export type Notification = {
  body: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type NotificationDetailsInput = {
  frequency: NotificationFrequency;
  notificationMethod: NotificationMethod;
};

export enum NotificationFrequency {
  Day = 'DAY',
  Week = 'WEEK'
}

export enum NotificationMethod {
  Email = 'EMAIL',
  Push = 'PUSH'
}

export type Notifications = {
  __typename?: 'Notifications';
  newCount: Scalars['Int']['output'];
  notifications: Array<Maybe<Notification>>;
};

export type OneTimeSavedSearchInput = {
  address: Scalars['String']['input'];
  searchQuery: Scalars['String']['input'];
};

export type OneTimeSavedSearchLegacyInput = {
  category: Scalars['Int']['input'];
  keywords: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type OrganicAd = AdCommon & {
  __typename?: 'OrganicAd';
  adDataArray: Array<AdDataPair>;
  attributes?: Maybe<AttributeMap>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  favourite: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  location?: Maybe<AdLocation>;
  locationId: Scalars['Int']['output'];
  price?: Maybe<Price>;
  recommendedAds?: Maybe<Array<Maybe<OrganicAd>>>;
  seoUrl?: Maybe<Scalars['String']['output']>;
  sortingDate?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  suggestedPrice?: Maybe<Scalars['Long']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type OrganicAdLocationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type OrganicAdRecommendedAdsArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type OtherUserProfile = {
  __typename?: 'OtherUserProfile';
  id: Scalars['Int']['output'];
  profileName?: Maybe<Scalars['String']['output']>;
};

export type OtherUserProfileData = {
  __typename?: 'OtherUserProfileData';
  otherUserProfile?: Maybe<OtherUserProfile>;
};

export enum PageType {
  Paf = 'PAF',
  Srp = 'SRP',
  Vip = 'VIP'
}

export type Pagination = {
  __typename?: 'Pagination';
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PaginationInput = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PaginationInputV2 = {
  /** How many items per page. */
  limit: Scalars['Int']['input'];
  /** Starting index of fetched items. Want page 3 of limit 10? Offset = 20. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationLimitOffset = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Participant = {
  __typename?: 'Participant';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type Partner = {
  __typename?: 'Partner';
  brand: PartnerBrand;
  title?: Maybe<Scalars['String']['output']>;
};

export type PartnerBrand = {
  __typename?: 'PartnerBrand';
  link?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type PendingLocation = {
  __typename?: 'PendingLocation';
  area?: Maybe<LocationArea>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type PendingSearchInput = {
  __typename?: 'PendingSearchInput';
  additionalFlagFilters?: Maybe<Array<AdditionalFlags>>;
  attributeFilters?: Maybe<Array<AppliedAttributeFilter>>;
  by?: Maybe<SrpSortBy>;
  dateFilters?: Maybe<Array<AppliedDateFilter>>;
  dateRangeFilters?: Maybe<Array<AppliedDateRangeFilter>>;
  direction?: Maybe<SortDirection>;
  keywords?: Maybe<Scalars['String']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  rangeFilters?: Maybe<Array<AppliedRangeFilter>>;
  toggleFilters?: Maybe<Array<AppliedToggleFilter>>;
};

/** Account type for FSBO/Personal accounts */
export type PersonalAccount = Account & {
  __typename?: 'PersonalAccount';
  /** Account type, personal or business */
  accountType: Scalars['String']['output'];
  /** Street Address */
  address?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['EmailAddress']['output']>;
  /** User Id */
  id: Scalars['ID']['output'];
  /** Display name */
  name?: Maybe<Scalars['NonEmptyString']['output']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Account preferences and opt-ins */
  preferences?: Maybe<AccountPreferences>;
  /** User profile image url */
  profileUrl?: Maybe<Scalars['String']['output']>;
  /** Social media links */
  socialLinks?: Maybe<AccountSocialLinks>;
};

export type PlaceDetails = {
  __typename?: 'PlaceDetails';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<AddressFormat>;
  id?: Maybe<Scalars['String']['output']>;
  isCity: Scalars['Boolean']['output'];
  isCountry: Scalars['Boolean']['output'];
  isPostalCode: Scalars['Boolean']['output'];
  isProvince: Scalars['Boolean']['output'];
  isStreetAddress: Scalars['Boolean']['output'];
  location?: Maybe<LocationCoordinates>;
  postalCode?: Maybe<AddressFormat>;
  province?: Maybe<AddressFormat>;
  viewport?: Maybe<ViewportType>;
};

export type PlaceSuggestions = {
  __typename?: 'PlaceSuggestions';
  address?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PopularAttribute = {
  __typename?: 'PopularAttribute';
  canonicalName?: Maybe<Scalars['String']['output']>;
  localizedName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PopularAttributes = {
  __typename?: 'PopularAttributes';
  localizedSeoUrl?: Maybe<Scalars['String']['output']>;
  seoAttributes?: Maybe<Array<Maybe<PopularAttribute>>>;
};


export type PopularAttributesLocalizedSeoUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type PopularAttributesSeoAttributesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type PopularCategoryItem = {
  __typename?: 'PopularCategoryItem';
  id: Scalars['ID']['output'];
  seoUrl: Scalars['String']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PosterInfo = {
  __typename?: 'PosterInfo';
  allowEmailContact?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  posterId: Scalars['ID']['output'];
  posterType?: Maybe<PosterType>;
  profile?: Maybe<Profile>;
  sellerType: SellerType;
  websiteUrl?: Maybe<Scalars['URL']['output']>;
};

export enum PosterSource {
  Belen = 'BELEN',
  Commercial = 'COMMERCIAL',
  Private = 'PRIVATE'
}

/** Used for ODIN? What are all possible values? */
export enum PosterType {
  Commercial = 'COMMERCIAL',
  Private = 'PRIVATE'
}

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PriceDistribution = {
  __typename?: 'PriceDistribution';
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  numBuckets?: Maybe<Scalars['Int']['output']>;
  resultBuckets?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type PriceDistributionOptions = {
  attributeFilters?: InputMaybe<Array<InputMaybe<AttributeInput>>>;
  categoryId: Scalars['Int']['input'];
  location?: InputMaybe<RadialLocationInput>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  maxPrice: Scalars['Int']['input'];
  minPrice: Scalars['Int']['input'];
  numBuckets: Scalars['Int']['input'];
};

export type PriceInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type PriceRating = {
  __typename?: 'PriceRating';
  accuracy?: Maybe<Scalars['Int']['output']>;
  averagePrice?: Maybe<AveragePrice>;
  provider?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['String']['output']>;
  ratingThresholds?: Maybe<RatingThresholds>;
};

export enum PriceType {
  Contact = 'CONTACT',
  Fixed = 'FIXED',
  GiveAway = 'GIVE_AWAY',
  Monthly = 'MONTHLY',
  Offer = 'OFFER',
  SwapTrade = 'SWAP_TRADE'
}

/** Deprecated: Use ProfileV2 instead */
export type Profile = {
  __typename?: 'Profile';
  companyName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isAdmarkt?: Maybe<Scalars['Boolean']['output']>;
  isProfessional?: Maybe<Scalars['Boolean']['output']>;
  isReadIndicatorEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSfidEnabled?: Maybe<Scalars['Boolean']['output']>;
  memberSince?: Maybe<Scalars['Long']['output']>;
  numberOfOrganicAds?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<Scalars['String']['output']>;
  replyRate?: Maybe<Scalars['Int']['output']>;
  responsiveness?: Maybe<Scalars['String']['output']>;
};

export type ProfileImageInput = {
  image: Scalars['Upload']['input'];
  size: Scalars['Int']['input'];
  xsrfToken: Scalars['String']['input'];
};

/** Different sort by list compared to SRP */
export enum ProfileSortBy {
  Date = 'DATE',
  Price = 'PRICE'
}

export type ProfileSortInput = {
  by: ProfileSortBy;
  direction: SortDirection;
};

export enum ProfileType {
  CasMerchant = 'CAS_MERCHANT',
  Dealer = 'DEALER',
  Fsbo = 'FSBO',
  HeDealer = 'HE_DEALER',
  JobsProfessional = 'JOBS_PROFESSIONAL',
  PvDealer = 'PV_DEALER',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  ReProfessional = 'RE_PROFESSIONAL',
  RvDealer = 'RV_DEALER'
}

export type ProfileUpdateResponse = {
  __typename?: 'ProfileUpdateResponse';
  userDetails?: Maybe<UserProfile>;
};

export type ProfileV2 = {
  /** The ID of the profile, can start with COMMERCIAL_ for non BOX accounts */
  id: Scalars['ID']['output'];
  listings?: Maybe<Array<FullListing>>;
  name: Scalars['String']['output'];
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userType: UserType;
};


export type ProfileV2ListingsArgs = {
  pagination: PaginationInputV2;
  sort: ProfileSortInput;
};


export type ProfileV2PhoneNumberArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ProfileV2Type {
  Commercial = 'COMMERCIAL',
  Standard = 'STANDARD'
}

export enum ProvinceAbbreviation {
  Ab = 'AB',
  Bc = 'BC',
  Mb = 'MB',
  Nb = 'NB',
  Nl = 'NL',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  On = 'ON',
  Ooc = 'OOC',
  Pe = 'PE',
  Qc = 'QC',
  Sk = 'SK',
  Yt = 'YT'
}

export type Query = {
  __typename?: 'Query';
  ad?: Maybe<Ad>;
  authModalState: AuthModalState;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  category?: Maybe<Category>;
  categoryLinks?: Maybe<Array<Maybe<CategoryLink>>>;
  clientList?: Maybe<Array<Maybe<ClientSelectionDetail>>>;
  contentModule?: Maybe<ContentModule>;
  conversationIdByAdId?: Maybe<ConversationId>;
  covidResponse?: Maybe<CovidResponse>;
  /** Get the dealer phone number from MoVe's Call Tracking vendor (Freespee) */
  dealerPhoneNumber: Scalars['String']['output'];
  dismissedStates: DismissedStates;
  dropInConfiguration?: Maybe<DropInConfiguration>;
  eligibility?: Maybe<ReviewEligibility>;
  /** Fetch the users full list of favourite ids */
  favouriteListingsIds: Array<Scalars['ID']['output']>;
  /** https://pages.github.es.ecg.tools/ecg-kijiji-ca/gcp-cloud/#/default/lookupsavedsearch */
  favouriteSearchIdLookup?: Maybe<FavouriteSearchIdLookupOutput>;
  favouritesList?: Maybe<Array<Maybe<FavouriteEntry>>>;
  favouritesListings?: Maybe<Array<Maybe<FavouriteListing>>>;
  feedRecommendations?: Maybe<FeedRecommendations>;
  feedbackOptions: Array<FeedbackOption>;
  feedbackSummary: Array<Maybe<FeedbackSummaryItem>>;
  /** @deprecated Use profile instead */
  findCommercialProfile?: Maybe<CommercialProfile>;
  /** @deprecated Use profile instead */
  findProfile: Profile;
  /** @deprecated No longer supported */
  findProfiles: Array<Profile>;
  geocodeCanadianAddress?: Maybe<GeocodeCanadianAddress>;
  geocodeReverseFromIp: GeocodeReverseFromIp;
  getAllFavouriteSearch?: Maybe<GetAllFavouriteSearchResponse>;
  getDynamicPhoneNumber?: Maybe<DynamicPhoneNumber>;
  getMoveSRPUrl?: Maybe<Scalars['String']['output']>;
  hasMoveListings: Scalars['Boolean']['output'];
  homeFeed?: Maybe<HomeFeed>;
  homeFeedAds: HomeFeedAds;
  homepageGallery?: Maybe<HomepageGallery>;
  initialStructuredMessage?: Maybe<Array<Maybe<StructuredMessage>>>;
  /** Check if the autos listing is digital retail elibigible to determine if the associated UI should be displayed */
  isDigitalRetailEligible: Scalars['Boolean']['output'];
  landingPageContent?: Maybe<LandingPageContent>;
  /** Get a listing by its id */
  listing?: Maybe<FullListing>;
  listingUrl: Scalars['URL']['output'];
  listings?: Maybe<Listings>;
  listingsRecommendedForYou?: Maybe<Array<Maybe<CoreListing>>>;
  /** Get similar listings to the inputted listing id */
  listingsSimilar?: Maybe<Array<CoreListing>>;
  /** Fetch the user platform ID from LivePerson. */
  livePersonGetIDs?: Maybe<LivePersonIDs>;
  location?: Maybe<Location>;
  locationFromCoordinates?: Maybe<LocationWithPlace>;
  locationFromPlace?: Maybe<LocationWithPlace>;
  locationPath?: Maybe<Array<Maybe<Location>>>;
  menu?: Maybe<MenuItem>;
  menuPrefetch?: Maybe<Array<Maybe<MenuItem>>>;
  /** Get my account information */
  myAccount?: Maybe<Account>;
  myAdListing?: Maybe<OrganicAd>;
  notifications: Notifications;
  placeSuggestions?: Maybe<Array<Maybe<PlaceSuggestions>>>;
  popularAttributes?: Maybe<Array<Maybe<PopularAttributes>>>;
  priceDistribution?: Maybe<PriceDistribution>;
  /** Get a profile by its id */
  profile: ProfileV2;
  review?: Maybe<Review>;
  reviewDetailSummary: Array<ReviewDetailDirectedSummary>;
  reviewSummary: ReviewSummary;
  reviews: Reviews;
  /**
   * Query to fetch Google reviews for a specific dealer by their dealerId.
   * Arguments:
   * - dealerId (Int!): Unique dealer identifier
   * Returns:
   * - GoogleReviews: Object containing overall rating, review count, profile URL, and reviews list
   */
  reviewsFromGoogle?: Maybe<GoogleReviews>;
  searchCategories?: Maybe<Array<Maybe<Category>>>;
  searchInputFromUrl: Scalars['String']['output'];
  searchResultsPage: SearchResultsPage;
  /** With an SRP SEO url, query for the search results page. */
  searchResultsPageByUrl: SearchResultsPage;
  /**
   * By query object, sorted & paginated sorted listings search that includes search filters and extended search query data.
   * Slow decorator should be removed or at least adjusted once we have optimized the category/location calls.
   */
  searchResultsPageUpdate: SearchResultsPage;
  /** Returns an SEO formatted url from SRP input */
  searchUrl?: Maybe<Scalars['URL']['output']>;
  /** Returns a set of popular or related keyword search urls by category and location. */
  searchUrlsPopular?: Maybe<Array<LabeledUrl>>;
  srp: SearchResultsPageState;
  structuredMessage?: Maybe<Array<Maybe<StructuredMessage>>>;
  transaction?: Maybe<TransactionDetails>;
  /** Returns logged in users conversationsWithUnreadMessagesCount */
  unreadConversationsCount: Scalars['Int']['output'];
  unreadNotificationsCount: Scalars['Int']['output'];
  user?: Maybe<User>;
  userAuthState: UserAuthState;
  userConversations?: Maybe<UserConversations>;
  userLocale: UserLocale;
  userLocation: UserLocation;
};


export type QueryAdArgs = {
  id: Scalars['Int']['input'];
  source?: InputMaybe<AdSource>;
};


export type QueryCampaignsArgs = {
  categoryId: Scalars['Int']['input'];
  customType?: InputMaybe<Scalars['String']['input']>;
  filterAmount?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  placement: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategoryLinksArgs = {
  linkInfo?: InputMaybe<Array<InputMaybe<CategoryLinkInfo>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryClientListArgs = {
  adId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentModuleArgs = {
  locationId: Scalars['Int']['input'];
  moduleId: ContentModuleId;
};


export type QueryConversationIdByAdIdArgs = {
  adId: Scalars['Int']['input'];
};


export type QueryCovidResponseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealerPhoneNumberArgs = {
  adId?: InputMaybe<Scalars['Int']['input']>;
  contactType?: InputMaybe<ContactType>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  sellerId: Scalars['Int']['input'];
};


export type QueryDropInConfigurationArgs = {
  userId: Scalars['Int']['input'];
  xsrfToken: Scalars['String']['input'];
};


export type QueryEligibilityArgs = {
  conversationId: Scalars['String']['input'];
  listingId: Scalars['String']['input'];
  revieweeId: Scalars['Int']['input'];
  reviewerId: Scalars['Int']['input'];
};


export type QueryFavouriteSearchIdLookupArgs = {
  input: FavouriteSearchIdLookupInput;
};


export type QueryFavouritesListArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryFavouritesListingsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryFeedRecommendationsArgs = {
  input: FeedRecommendationsInput;
};


export type QueryFeedbackSummaryArgs = {
  revieweeId: Scalars['Int']['input'];
};


export type QueryFindCommercialProfileArgs = {
  contactType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  isBoxDealer?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindProfileArgs = {
  id?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryFindProfilesArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type QueryGeocodeCanadianAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetAllFavouriteSearchArgs = {
  input: PaginationLimitOffset;
};


export type QueryGetDynamicPhoneNumberArgs = {
  adId: Scalars['String']['input'];
  listingType: Scalars['String']['input'];
  sellerName: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  vipUrl: Scalars['String']['input'];
};


export type QueryGetMoveSrpUrlArgs = {
  attributesQueryString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHasMoveListingsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryHomeFeedArgs = {
  homePageMixGroup?: InputMaybe<Scalars['String']['input']>;
  input: HomeFeedInput;
};


export type QueryHomepageGalleryArgs = {
  deviceType: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  numberOfAds?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryInitialStructuredMessageArgs = {
  categoryId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIsDigitalRetailEligibleArgs = {
  adId: Scalars['Int']['input'];
};


export type QueryLandingPageContentArgs = {
  landingPageName: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingsArgs = {
  searchParams?: InputMaybe<ItemSearchOptions>;
};


export type QueryListingsRecommendedForYouArgs = {
  listingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryListingsSimilarArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingId: Scalars['ID']['input'];
};


export type QueryLivePersonGetIDsArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLocationFromCoordinatesArgs = {
  coordinates?: InputMaybe<LocationQueryCoordsOptions>;
};


export type QueryLocationFromPlaceArgs = {
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  placeId: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationPathArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMenuArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryMenuPrefetchArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};


export type QueryMyAdListingArgs = {
  adId: Scalars['Int']['input'];
};


export type QueryNotificationsArgs = {
  lastSeenNotificationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryPlaceSuggestionsArgs = {
  input: Scalars['String']['input'];
  location?: InputMaybe<LocationQueryCoordsOptions>;
};


export type QueryPopularAttributesArgs = {
  categoryId: Scalars['Int']['input'];
  conditionalFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPriceDistributionArgs = {
  searchParams?: InputMaybe<PriceDistributionOptions>;
};


export type QueryProfileArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<ProfileV2Type>;
};


export type QueryReviewArgs = {
  listingId: Scalars['String']['input'];
  revieweeId: Scalars['Int']['input'];
  reviewerId: Scalars['Int']['input'];
};


export type QueryReviewDetailSummaryArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryReviewSummaryArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryReviewsArgs = {
  lastSeenReviewId?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryReviewsFromGoogleArgs = {
  dealerId: Scalars['ID']['input'];
};


export type QuerySearchCategoriesArgs = {
  selectedId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchInputFromUrlArgs = {
  input: SearchInputFromUrlInput;
};


export type QuerySearchResultsPageArgs = {
  by: SearchResultsPageInputBy;
  pagination: PaginationInputV2;
  sorting?: InputMaybe<SrpSortInput>;
};


export type QuerySearchResultsPageByUrlArgs = {
  input: SearchResultsByUrlInput;
};


export type QuerySearchResultsPageUpdateArgs = {
  input: SearchResultsInput;
};


export type QuerySearchUrlArgs = {
  input: SearchUrlInput;
};


export type QuerySearchUrlsPopularArgs = {
  input: SearchUrlPopularRelatedInput;
};


export type QueryStructuredMessageArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<RoleType>;
};


export type QueryTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type RadialLocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius: Scalars['Int']['input'];
};

export type RangeControlValues = MinMax | StartEndDate;

/** Schema for Range Controls */
export type RangeFilter = Filter & {
  __typename?: 'RangeFilter';
  fromRange: MinMax;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  rangeLabels: RangeLabels;
  selectedRangeValues?: Maybe<RangeControlValues>;
  toRange: MinMax;
  type: FilterControlType;
};

export type RangeFilterInput = {
  filterName: Scalars['String']['input'];
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

export type RangeLabels = {
  __typename?: 'RangeLabels';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type RatingThresholds = {
  __typename?: 'RatingThresholds';
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  midHigh?: Maybe<Scalars['Float']['output']>;
  midLow?: Maybe<Scalars['Float']['output']>;
};

export type RealEstateListing = FullListing & Listing & {
  __typename?: 'RealEstateListing';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  /** Real Estate Listing fields */
  attributes: RealEstateListingAttributes;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  flags: RealEstateListingFlags;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocation;
  mlsAd?: Maybe<Scalars['Boolean']['output']>;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  views?: Maybe<Scalars['Int']['output']>;
  virtualTourUrl?: Maybe<Scalars['URL']['output']>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type RealEstateListingAttributes = ListingAttributes & {
  __typename?: 'RealEstateListingAttributes';
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type RealEstateListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RealEstateListingFlags = ListingFlags & {
  __typename?: 'RealEstateListingFlags';
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  /** Listing flags that only apply to Real Estate categories */
  comfree?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
  viewingAvailable?: Maybe<Scalars['Boolean']['output']>;
  virtualTour?: Maybe<Scalars['Boolean']['output']>;
};

export enum Reason {
  Duplicated = 'DUPLICATED',
  Irrelevant = 'IRRELEVANT',
  Miscategorized = 'MISCATEGORIZED',
  Other = 'OTHER',
  Prohibited = 'PROHIBITED',
  VideoMatureOrProhibited = 'VIDEO_MATURE_OR_PROHIBITED'
}

export type RecentlyViewedListings = BaseListing & {
  __typename?: 'RecentlyViewedListings';
  categoryId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationId: Scalars['Int']['output'];
  price: Price;
  seoUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum RecommendationProcessor {
  SimilarToFavourites = 'SIMILAR_TO_FAVOURITES'
}

export type RegisterUserInput = {
  additionalData?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fraudToken?: InputMaybe<Scalars['String']['input']>;
  kjses?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  profileName: Scalars['String']['input'];
  recaptchaResponse?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  xsrfToken?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterUserResponse = {
  __typename?: 'RegisterUserResponse';
  message: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
};

export type RelatedSeoUrlGroup = {
  __typename?: 'RelatedSeoUrlGroup';
  label: Scalars['String']['output'];
  relatedUrls: Array<LabeledUrl>;
};

export type RepostAdResponse = {
  __typename?: 'RepostAdResponse';
  status?: Maybe<RepostAdStatus>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum RepostAdStatus {
  Ok = 'OK',
  Redirect = 'REDIRECT'
}

export type RequestPasswordResetLinkInput = {
  email: Scalars['EmailAddress']['input'];
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  redirectUrl: Scalars['URL']['input'];
};

export enum ResponseCode {
  Authorised = 'AUTHORISED',
  Error = 'ERROR',
  Redirectshopper = 'REDIRECTSHOPPER',
  Refused = 'REFUSED'
}

/** V2 of Profile */
export enum Responsiveness {
  Over_72Hours = 'OVER_72_HOURS',
  Under_2Hours = 'UNDER_2_HOURS',
  Under_6Hours = 'UNDER_6_HOURS',
  Under_24Hours = 'UNDER_24_HOURS',
  Under_72Hours = 'UNDER_72_HOURS'
}

export type Review = {
  __typename?: 'Review';
  categoryName?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  dateCreated?: Maybe<Scalars['Int']['output']>;
  direction: Direction;
  feedbackOptions?: Maybe<Array<FeedbackOption>>;
  id: Scalars['Int']['output'];
  listingId: Scalars['String']['output'];
  reviewedBy?: Maybe<Profile>;
  revieweeId: Scalars['Int']['output'];
  reviewerId: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type ReviewDetailDirectedSummary = {
  __typename?: 'ReviewDetailDirectedSummary';
  direction: Direction;
  scoreSummary: Array<ScoreSummary>;
};

export type ReviewEligibility = {
  __typename?: 'ReviewEligibility';
  eligibilityDate?: Maybe<Scalars['Int']['output']>;
  isEligible: Scalars['Boolean']['output'];
  waitPeriodToPublishReview?: Maybe<Scalars['Int']['output']>;
};

export type ReviewInput = {
  categoryId: Scalars['Int']['input'];
  conversationId: Scalars['String']['input'];
  direction: Direction;
  feedbackIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listingId: Scalars['String']['input'];
  revieweeId: Scalars['Int']['input'];
  reviewerId: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
};

export type ReviewSummary = {
  __typename?: 'ReviewSummary';
  sumScore: Scalars['Int']['output'];
  totalReviews: Scalars['Int']['output'];
};

export type Reviews = {
  __typename?: 'Reviews';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Review>;
};

export enum RoleType {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type SdkData = {
  __typename?: 'SDKData';
  token: Scalars['String']['output'];
};

export type SrpListing = BaseListing & {
  __typename?: 'SRPListing';
  attributeMap?: Maybe<AttributeMap>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasCarproof?: Maybe<Scalars['Boolean']['output']>;
  hasFinancing?: Maybe<Scalars['Boolean']['output']>;
  hasIncentives?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  images?: Maybe<Array<Maybe<Image>>>;
  isDisplayPriceDrop?: Maybe<Scalars['Boolean']['output']>;
  isHighLight?: Maybe<Scalars['Boolean']['output']>;
  isPriceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProvincialTopAd?: Maybe<Scalars['Boolean']['output']>;
  isUrgent?: Maybe<Scalars['Boolean']['output']>;
  isVeteranFriendly?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<AdLocation>;
  locationId: Scalars['Int']['output'];
  originalPrice?: Maybe<Price>;
  posterLogoUrl?: Maybe<Scalars['String']['output']>;
  price: Price;
  sortingDate: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum SrpSortBy {
  Date = 'DATE',
  Distance = 'DISTANCE',
  Match = 'MATCH',
  Mileage = 'MILEAGE',
  Price = 'PRICE',
  StartDate = 'START_DATE'
}

export type SrpSortInput = {
  by: SrpSortBy;
  direction: SortDirection;
};

export type ScoreSummary = {
  __typename?: 'ScoreSummary';
  count: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type SearchCategory = {
  __typename?: 'SearchCategory';
  id: Scalars['Int']['output'];
  isDomCat?: Maybe<Scalars['Boolean']['output']>;
  localizedName: Scalars['String']['output'];
  name?: Maybe<Locale>;
  parentId?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Array<SearchCategoryPath>>;
  seoUrl?: Maybe<Scalars['String']['output']>;
};

export type SearchCategoryPath = {
  __typename?: 'SearchCategoryPath';
  id: Scalars['Int']['output'];
  localizedName: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  seoUrl?: Maybe<Scalars['String']['output']>;
};

export type SearchControls = {
  __typename?: 'SearchControls';
  filtering: Array<FilterGroup>;
  sorting: Array<SortOption>;
};

export type SearchInputFromUrlInput = {
  pagination: PaginationInputV2;
  url: Scalars['URL']['input'];
};

export enum SearchOrigin {
  Algolia = 'ALGOLIA',
  Browse = 'BROWSE',
  OrganicKeyword = 'ORGANIC_KEYWORD',
  RecentSearch = 'RECENT_SEARCH',
  SavedSearch = 'SAVED_SEARCH'
}

export type SearchQuery = {
  __typename?: 'SearchQuery';
  area?: Maybe<LocationArea>;
  category?: Maybe<Category>;
  categoryId: Scalars['Int']['output'];
  filters: Array<AppliedFilter>;
  keywords?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['Int']['output'];
  priceType?: Maybe<FilterPriceType>;
  /** The raw search query string to be used for favouriting searches. */
  searchString: Scalars['String']['output'];
  seoUrl?: Maybe<Scalars['URL']['output']>;
};

export type SearchQueryInput = {
  additionalFlagFilters?: InputMaybe<Array<AdditionalFlags>>;
  attributeFilters?: InputMaybe<Array<AttributeFilterInput>>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  dateFilters?: InputMaybe<Array<DateFilterInput>>;
  dateRangeFilters?: InputMaybe<Array<DateRangeFilterInput>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  location: LocationInput;
  origin?: InputMaybe<SearchOrigin>;
  priceType?: InputMaybe<FilterPriceType>;
  rangeFilters?: InputMaybe<Array<RangeFilterInput>>;
  toggleFilters?: InputMaybe<Array<ToggleFilterInput>>;
  topAdCount?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchResults = {
  __typename?: 'SearchResults';
  mainListings: Array<FullListing>;
  topListings: Array<FullListing>;
};

export type SearchResultsByUrlInput = {
  pagination: PaginationInputV2;
  url: Scalars['URL']['input'];
};

export type SearchResultsInput = {
  pagination: PaginationInputV2;
  searchQuery: SearchQueryInput;
  sorting?: InputMaybe<SrpSortInput>;
};

export type SearchResultsPage = {
  __typename?: 'SearchResultsPage';
  /** Contains the SRP Filtering section controls, and the sorting controls info along with selected values. */
  controls: SearchControls;
  /** Pagination and total results details. */
  pagination: Pagination;
  /** New listing array of normalized listings with organic, CAS, and MOVE listings. */
  results?: Maybe<SearchResults>;
  /** The parameters used to query the search as verified by the response. */
  searchQuery: SearchQuery;
};

export type SearchResultsPageInputBy = {
  query?: InputMaybe<SearchQueryInput>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type SearchResultsPageState = {
  __typename?: 'SearchResultsPageState';
  isFilterDrawerOpen: Scalars['Boolean']['output'];
  loadingFilters: Scalars['Boolean']['output'];
  loadingResults: Scalars['Boolean']['output'];
  pendingSearchInput?: Maybe<PendingSearchInput>;
  searchCategory: SearchCategory;
  searchKeyword?: Maybe<Scalars['String']['output']>;
  selectedAccordionItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type SearchUrlInput = {
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery: SearchQueryInput;
  sorting?: InputMaybe<SrpSortInput>;
};

export type SearchUrlPopularRelatedInput = {
  categoryId: Scalars['ID']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  location: LocationInput;
};

export enum SellerType {
  Commercial = 'COMMERCIAL',
  Fsbo = 'FSBO',
  Kmb = 'KMB'
}

/** Shared ENUMS */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortOption = {
  __typename?: 'SortOption';
  by: SrpSortBy;
  direction: SortDirection;
  isSelected: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export type StandardAmountPrice = AmountPrice & ListingPrice & {
  __typename?: 'StandardAmountPrice';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  originalAmount?: Maybe<Scalars['Float']['output']>;
  type: ListingPriceType;
};

export type StandardListing = FullListing & Listing & {
  __typename?: 'StandardListing';
  activationDate?: Maybe<Scalars['DateTime']['output']>;
  adSource: AdSource;
  attributes?: Maybe<ListingAttributes>;
  categoryId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalSource?: Maybe<ExternalListingSource>;
  flags: ListingFlags;
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['URL']['output']>;
  location: ListingLocation;
  posterInfo: PosterInfo;
  price?: Maybe<ListingPrice>;
  sortingDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: AdType;
  url: Scalars['URL']['output'];
  views?: Maybe<Scalars['Int']['output']>;
  youtubeVideoId?: Maybe<Scalars['String']['output']>;
};

export type StandardListingAttributes = ListingAttributes & {
  __typename?: 'StandardListingAttributes';
  all?: Maybe<Array<Maybe<ListingAttributeV2>>>;
  srpLogoUrl?: Maybe<Scalars['URL']['output']>;
};


export type StandardListingAttributesAllArgs = {
  filterFor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StandardListingFlags = ListingFlags & {
  __typename?: 'StandardListingFlags';
  categorySpecificBadge?: Maybe<Scalars['Boolean']['output']>;
  hasVideo?: Maybe<Scalars['Boolean']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  hpGallery?: Maybe<Scalars['Boolean']['output']>;
  isPromotionProvTopAd?: Maybe<Scalars['Boolean']['output']>;
  isPromotionTopAd?: Maybe<Scalars['Boolean']['output']>;
  priceDrop?: Maybe<Scalars['Boolean']['output']>;
  shippedBySeller?: Maybe<Scalars['Boolean']['output']>;
  showcase?: Maybe<Scalars['Boolean']['output']>;
  topAd?: Maybe<Scalars['Boolean']['output']>;
};

export type StandardNotification = Notification & {
  __typename?: 'StandardNotification';
  body: Scalars['String']['output'];
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StandardProfileV2 = ProfileV2 & {
  __typename?: 'StandardProfileV2';
  /** @deprecated For backwards compatibility */
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['URL']['output']>;
  /** @deprecated For backwards compatibility */
  isAdmarkt: Scalars['Boolean']['output'];
  isReadIndicatorEnabled: Scalars['Boolean']['output'];
  isSalesforceEnabled: Scalars['Boolean']['output'];
  listings?: Maybe<Array<FullListing>>;
  memberSince?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  numberOfListings?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  replyRate?: Maybe<Scalars['Int']['output']>;
  responsiveness?: Maybe<Responsiveness>;
  userType: UserType;
};


export type StandardProfileV2ListingsArgs = {
  pagination: PaginationInputV2;
  sort: ProfileSortInput;
};


export type StandardProfileV2PhoneNumberArgs = {
  listingId?: InputMaybe<Scalars['ID']['input']>;
};

export type StartEndDate = {
  __typename?: 'StartEndDate';
  end?: Maybe<Scalars['Date']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type StatusResponse = {
  __typename?: 'StatusResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type StructuredMessage = {
  __typename?: 'StructuredMessage';
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type SubmitPaymentResponse = {
  __typename?: 'SubmitPaymentResponse';
  nextPaymentAction?: Maybe<NextPaymentAction>;
  responseCode: ResponseCode;
  responseMessage?: Maybe<Scalars['String']['output']>;
  transactionContext?: Maybe<TransactionContext>;
};

export type SurveyAnswerInput = {
  id: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyQuestionInput = {
  answers: Array<InputMaybe<SurveyAnswerInput>>;
  id: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyUserInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TileArrangement = {
  __typename?: 'TileArrangement';
  desktop?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  tablet?: Maybe<Scalars['String']['output']>;
};

export enum TileDisplayFormat {
  Carousel = 'CAROUSEL',
  Grid = 'GRID'
}

export enum TileStyle {
  Article = 'ARTICLE',
  FullImage = 'FULL_IMAGE'
}

/** Schema for Toggle Filters */
export type ToggleFilter = Filter & {
  __typename?: 'ToggleFilter';
  isSelected: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentName?: Maybe<Scalars['String']['output']>;
  trueValue: Scalars['String']['output'];
  type: FilterControlType;
};

export type ToggleFilterInput = {
  filterName: Scalars['String']['input'];
  toggleValue: Scalars['String']['input'];
};

export type TotalListings = {
  __typename?: 'TotalListings';
  CAS?: Maybe<Scalars['Int']['output']>;
  ORGANIC?: Maybe<Scalars['Int']['output']>;
  ZIP?: Maybe<Scalars['Int']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  action: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nonInteraction?: Maybe<Scalars['Int']['output']>;
};

export type TransactionContext = {
  __typename?: 'TransactionContext';
  invoice: Scalars['String']['output'];
  targetIds: Array<Scalars['ID']['output']>;
};

export type TransactionData = {
  __typename?: 'TransactionData';
  transactionId: Scalars['ID']['output'];
};

export type TransactionDetails = {
  __typename?: 'TransactionDetails';
  ad?: Maybe<OrganicAd>;
  conversationId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isListingOwner?: Maybe<Scalars['Boolean']['output']>;
  listingId: Scalars['Int']['output'];
  otherUserProfile?: Maybe<Profile>;
  transactionStatus: TransactionStatus;
  waitPeriodToPublishReview?: Maybe<Scalars['Int']['output']>;
};

export enum TransactionStatus {
  ClientConfirmed = 'CLIENT_CONFIRMED',
  ClientDenied = 'CLIENT_DENIED',
  ClientReviewed = 'CLIENT_REVIEWED',
  HandshakeExpired = 'HANDSHAKE_EXPIRED',
  OwnerCreated = 'OWNER_CREATED',
  OwnerReviewed = 'OWNER_REVIEWED',
  ReviewExpired = 'REVIEW_EXPIRED'
}

export type UpdatePasswordInput = {
  /** New password */
  newPassword: Scalars['String']['input'];
  /** Current password */
  oldPassword: Scalars['String']['input'];
};

export type UpdatePersonalInformationInput = {
  /** Update the user's address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The user's email address. Even if this value is unchanged, it needs to be sent to make sure the user's email address doesn't get changed to blank */
  email: Scalars['EmailAddress']['input'];
  /** The user's full name. Even if this value is unchanged, it needs to be sent to make sure the name doesn't get changed to blank */
  name: Scalars['NonEmptyString']['input'];
  /** Update the phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePreferencesInput = {
  /** Yes, I would like Kijiji and its corporate family members to contact me about events, new features, and other promotional information. */
  contactMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide the visit counter on my ads (Only you will be able to see the visits number using My Ads). */
  hideVisit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Send me Bump Up and other feature notification emails. */
  pushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Read Receipts enabled (others will see when I've read their messages). */
  readReciepts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSocialLinksInput = {
  /** Update facebook url */
  facebook?: InputMaybe<Scalars['String']['input']>;
  /** Update Instagram url */
  instagram?: InputMaybe<Scalars['String']['input']>;
  /** Update LinkedIn url */
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** Update Pinterest url */
  pinterest?: InputMaybe<Scalars['String']['input']>;
  /** Update TikTok url */
  tiktok?: InputMaybe<Scalars['String']['input']>;
  /** Update Twitter url */
  twitter?: InputMaybe<Scalars['String']['input']>;
  /** Update Youtube url */
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UploadProfileImageResponse = {
  __typename?: 'UploadProfileImageResponse';
  /** Object filename returned when the image is uploaded */
  objectId: Scalars['String']['output'];
  /** URL path of the image */
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['Int']['output'];
  profile?: Maybe<Profile>;
  recentlyViewedListings?: Maybe<Array<Maybe<RecentlyViewedListings>>>;
};


export type UserRecentlyViewedListingsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type UserAuthState = {
  __typename?: 'UserAuthState';
  isMiddlewareAuthenticated?: Maybe<Scalars['Boolean']['output']>;
};

export type UserConversations = {
  __typename?: 'UserConversations';
  conversations?: Maybe<Array<Maybe<Conversation>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserEligibleToReviewNotification = Notification & {
  __typename?: 'UserEligibleToReviewNotification';
  body: Scalars['String']['output'];
  data: UserEligibleToReviewNotificationData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserEligibleToReviewNotificationData = {
  __typename?: 'UserEligibleToReviewNotificationData';
  otherUserProfile?: Maybe<OtherUserProfile>;
  transactionId?: Maybe<Scalars['ID']['output']>;
};

export type UserLocale = {
  __typename?: 'UserLocale';
  apiLocale: Scalars['String']['output'];
  cookieLocale: Scalars['String']['output'];
  languageKey: Scalars['String']['output'];
  routeLocale: Scalars['String']['output'];
};

export type UserLocation = {
  __typename?: 'UserLocation';
  area?: Maybe<LocationArea>;
  id: Scalars['Int']['output'];
  isRegion: Scalars['Boolean']['output'];
  name: Locale;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  companyName?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isAdmarkt?: Maybe<Scalars['Boolean']['output']>;
  isProfessional?: Maybe<Scalars['Boolean']['output']>;
  isSfidEnabled?: Maybe<Scalars['Boolean']['output']>;
  memberSince?: Maybe<Scalars['Float']['output']>;
  numberOfActiveAds?: Maybe<Scalars['Int']['output']>;
  numberOfOrganicAds?: Maybe<Scalars['Int']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  profileType?: Maybe<ProfileType>;
  responsiveness?: Maybe<Scalars['String']['output']>;
};

export type UserRegistrationInput = {
  /** Optional business name. If provided, a Business account is created (otherwise FSBO). */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Name to be displayed on the account's profile */
  displayName: Scalars['String']['input'];
  /** Account's primary email address */
  email: Scalars['EmailAddress']['input'];
  /** Account's password */
  password: Scalars['String']['input'];
  /** reCaptcha token */
  reCaptchaToken: Scalars['String']['input'];
  /** URL to redirect users back to after the account activation */
  redirectUrl: Scalars['String']['input'];
};

export type UserReviewCreatedNotification = Notification & {
  __typename?: 'UserReviewCreatedNotification';
  body: Scalars['String']['output'];
  data: OtherUserProfileData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type UserReviewPublishedNotification = Notification & {
  __typename?: 'UserReviewPublishedNotification';
  body: Scalars['String']['output'];
  data: OtherUserProfileData;
  dateCreated: Scalars['String']['output'];
  destinationUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pictureUrl?: Maybe<Scalars['String']['output']>;
  read: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum UserType {
  Admarkt = 'ADMARKT',
  CasMerchant = 'CAS_MERCHANT',
  Dealer = 'DEALER',
  Fsbo = 'FSBO',
  Guest = 'GUEST',
  HeDealer = 'HE_DEALER',
  JobsProfessional = 'JOBS_PROFESSIONAL',
  Professional = 'PROFESSIONAL',
  PvDealer = 'PV_DEALER',
  RealEstateAgent = 'REAL_ESTATE_AGENT',
  RetailProfessional = 'RETAIL_PROFESSIONAL',
  ReProfessional = 'RE_PROFESSIONAL',
  RvDealer = 'RV_DEALER',
  Unknown = 'UNKNOWN'
}

export type VehicleReport = {
  __typename?: 'VehicleReport';
  badgeKeys: Array<Scalars['String']['output']>;
  badges: Array<Scalars['String']['output']>;
  providerLogoUrl: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  reportUrl?: Maybe<Scalars['String']['output']>;
};

export type ViewportType = {
  __typename?: 'ViewportType';
  northeast?: Maybe<LatLngType>;
  southwest?: Maybe<LatLngType>;
};

export type NextPaymentAction = {
  __typename?: 'nextPaymentAction';
  paymentData: Scalars['String']['output'];
  paymentMethodType: Scalars['String']['output'];
  sdkData: SdkData;
  type: Scalars['String']['output'];
};

export type NotificationsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'Notifications', newCount: number, notifications: Array<{ __typename?: 'EasyPriceDropNotification', title: string, body: string, dateCreated: string, destinationUrl?: string | null, id: string, pictureUrl?: string | null, read: boolean, type: string } | { __typename?: 'StandardNotification', title: string, body: string, dateCreated: string, destinationUrl?: string | null, id: string, pictureUrl?: string | null, read: boolean, type: string } | { __typename?: 'UserEligibleToReviewNotification', title: string, body: string, dateCreated: string, destinationUrl?: string | null, id: string, pictureUrl?: string | null, read: boolean, type: string } | { __typename?: 'UserReviewCreatedNotification', title: string, body: string, dateCreated: string, destinationUrl?: string | null, id: string, pictureUrl?: string | null, read: boolean, type: string } | { __typename?: 'UserReviewPublishedNotification', title: string, body: string, dateCreated: string, destinationUrl?: string | null, id: string, pictureUrl?: string | null, read: boolean, type: string } | null> } };

export type GetUnreadNotificationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationDataQuery = { __typename?: 'Query', unreadConversationsCount: number, unreadNotificationsCount: number };

export type ChangePasswordViaResetLinkMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['UUID']['input'];
}>;


export type ChangePasswordViaResetLinkMutation = { __typename?: 'Mutation', changePasswordViaResetLink?: null | null };

export type GenerateXsrfMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateXsrfMutation = { __typename?: 'Mutation', generateXsrf?: { __typename?: 'GenerateXsrfResponse', message?: string | null, statusCode?: number | null, xsrf: string } | null };

export type LogoutUserMutationVariables = Exact<{
  input: LogoutUserInput;
}>;


export type LogoutUserMutation = { __typename?: 'Mutation', logoutUser?: { __typename?: 'LogoutUserResponse', message?: string | null, statusCode?: number | null } | null };

export type RequestPasswordResetLinkMutationVariables = Exact<{
  input: RequestPasswordResetLinkInput;
}>;


export type RequestPasswordResetLinkMutation = { __typename?: 'Mutation', requestPasswordResetLink?: null | null };

export type RegisterUserMutationVariables = Exact<{
  input: UserRegistrationInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', userRegistration?: null | null };

export type GetListingsSimilarQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetListingsSimilarQuery = { __typename?: 'Query', listingsSimilar?: Array<{ __typename?: 'CoreListing', categoryId: number, id: string, imageUrls: Array<string>, title: string, url: string, location: { __typename?: 'ListingLocation', name: string }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, type: ListingPriceType } | null }> | null };

export type GetMenuPrefetchQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  hints?: InputMaybe<Array<InputMaybe<Hints>> | InputMaybe<Hints>>;
}>;


export type GetMenuPrefetchQuery = { __typename?: 'Query', menuPrefetch?: Array<{ __typename?: 'MenuItem', id: number, categoryName: string, isLeaf: boolean, seoUrl: string, children?: Array<{ __typename?: 'MenuItem', categoryName: string, seoUrl: string, isLeaf: boolean, id: number, children?: Array<{ __typename?: 'MenuItem', categoryName: string, id: number, isLeaf: boolean, seoUrl: string } | null> | null } | null> | null } | null> | null };

export type GetProfileQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  size: LogoType;
}>;


export type GetProfileQuery = { __typename?: 'Query', profile: { __typename?: 'CommercialProfileV2', logoUrl?: string | null, phoneNumber?: string | null, staticMapUrl?: string | null, websiteUrl?: string | null, id: string, name: string, numberOfListings?: number | null, userType: UserType } | { __typename?: 'StandardProfileV2', imageUrl?: string | null, isSalesforceEnabled: boolean, id: string, name: string, numberOfListings?: number | null, userType: UserType } };

export type GetReviewSummaryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetReviewSummaryQuery = { __typename?: 'Query', reviewSummary: { __typename?: 'ReviewSummary', sumScore: number, totalReviews: number } };

export type GetCategoryNameQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type GetCategoryNameQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, localizedName?: string | null } | null };

export type GetProfileMetricsQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
}>;


export type GetProfileMetricsQuery = { __typename?: 'Query', profile: { __typename?: 'CommercialProfileV2', id: string } | { __typename?: 'StandardProfileV2', memberSince?: string | null, replyRate?: number | null, responsiveness?: Responsiveness | null, id: string } };

export type PersonalInformationFieldsFragment = { __typename?: 'PersonalAccount', accountType: string, id: string, name?: string | null, email?: string | null, address?: string | null, profileUrl?: string | null, phoneNumber?: string | null };

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'Query', myAccount?: { __typename?: 'PersonalAccount', accountType: string, id: string, name?: string | null, email?: string | null, address?: string | null, profileUrl?: string | null, phoneNumber?: string | null } | null };

export type GetAlgoliaKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GetAlgoliaKeyMutation = { __typename?: 'Mutation', getAlgoliaKey?: boolean | null };

export type GetCampaignsQueryVariables = Exact<{
  placement: Scalars['String']['input'];
  customType: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  categoryId: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
  filterAmount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns?: Array<{ __typename?: 'Campaign', customFields?: string | null, id: number } | null> | null };

export type GetCategoryPathQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCategoryPathQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null };

export type GetHomeFeedAdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeFeedAdsQuery = { __typename?: 'Query', homeFeedAds: { __typename?: 'HomeFeedAds', adSlots?: number | null } };

export type GetPsaDismissedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPsaDismissedQuery = { __typename?: 'Query', dismissedStates: { __typename?: 'DismissedStates', appDownloadPSA: boolean, siteMaintenancePSA_may7th: boolean } };

export type GetSearchCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchCategoryQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', searchCategory: { __typename?: 'SearchCategory', id: number, isDomCat?: boolean | null, localizedName: string, parentId?: number | null, seoUrl?: string | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null, path?: Array<{ __typename?: 'SearchCategoryPath', id: number, localizedName: string, parentId?: number | null, seoUrl?: string | null }> | null } } };

export type GetSearchKeywordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchKeywordQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', searchKeyword?: string | null } };

export type GetUserAuthStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAuthStateQuery = { __typename?: 'Query', userAuthState: { __typename?: 'UserAuthState', isMiddlewareAuthenticated?: boolean | null } };

export type GetUserLocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLocaleQuery = { __typename?: 'Query', userLocale: { __typename?: 'UserLocale', apiLocale: string, cookieLocale: string, languageKey: string, routeLocale: string } };

export type GetUserLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLocationQuery = { __typename?: 'Query', userLocation: { __typename?: 'UserLocation', id: number, isRegion: boolean, name: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null }, area?: { __typename?: 'LocationArea', latitude: number, longitude: number, radius: number, address?: string | null } | null } };

export type GetContentModuleQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  moduleId: ContentModuleId;
}>;


export type GetContentModuleQuery = { __typename?: 'Query', contentModule?: { __typename?: 'BrowseHeroModule', component: string, title: Array<{ __typename?: 'CustomizedText', text?: string | null, style?: { __typename?: 'CustomizedTextStyle', color?: string | null, isBold?: boolean | null } | null } | null>, partner?: { __typename?: 'Partner', title?: string | null, brand: { __typename?: 'PartnerBrand', logoUrl?: string | null, link?: string | null } } | null, tiles: Array<{ __typename?: 'BrowseTile', title: string, type?: string | null, link: { __typename?: 'LinkType', url: string, isNewTab?: boolean | null }, tracking?: { __typename?: 'Tracking', action: string, label: string } | null, background?: { __typename?: 'BackgroundType', imageUrl?: string | null, altText?: string | null } | null } | null> } | null };

export type FavouriteSearchActivateMutationVariables = Exact<{
  input: FavouriteSearchActivateInput;
}>;


export type FavouriteSearchActivateMutation = { __typename?: 'Mutation', favouriteSearchActivate: string };

export type FavouriteSearchActivateGuestMutationVariables = Exact<{
  searchString: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type FavouriteSearchActivateGuestMutation = { __typename?: 'Mutation', activateFavouriteSearchGuest?: number | null };

export type FavouriteSearchDeactivateMutationVariables = Exact<{
  favouriteSearchDeactivateId: Scalars['ID']['input'];
}>;


export type FavouriteSearchDeactivateMutation = { __typename?: 'Mutation', favouriteSearchDeactivate?: null | null };

export type FavouriteSearchIdLookupQueryVariables = Exact<{
  input: FavouriteSearchIdLookupInput;
}>;


export type FavouriteSearchIdLookupQuery = { __typename?: 'Query', favouriteSearchIdLookup?: { __typename?: 'FavouriteSearchIdLookupOutput', id: string, active: boolean } | null };

export type GetSearchCategoriesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetSearchCategoriesQuery = { __typename?: 'Query', searchCategories?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null } | null> | null };

export type GetGoogleMapsKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleMapsKeyMutation = { __typename?: 'Mutation', getGoogleMapsKey?: boolean | null };

export type GetPlaceSuggestionsQueryVariables = Exact<{
  input: Scalars['String']['input'];
  location?: InputMaybe<LocationQueryCoordsOptions>;
}>;


export type GetPlaceSuggestionsQuery = { __typename?: 'Query', placeSuggestions?: Array<{ __typename?: 'PlaceSuggestions', placeId?: string | null, address?: string | null } | null> | null };

export type GetPlaceTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetPlaceTokenMutation = { __typename?: 'Mutation', getPlaceToken?: boolean | null };

export type GetCategoriesNearYouQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetCategoriesNearYouQuery = { __typename?: 'Query', menuPrefetch?: Array<{ __typename?: 'MenuItem', id: number, categoryName: string, seoUrl: string } | null> | null };

export type GetFeedRecommendationsQueryVariables = Exact<{
  input: FeedRecommendationsInput;
}>;


export type GetFeedRecommendationsQuery = { __typename?: 'Query', feedRecommendations?: { __typename?: 'FeedRecommendations', seedId: number, description: string, seoUrl: string, ads?: Array<{ __typename?: 'FeedItem', id: string, imageUrls?: Array<string | null> | null, seoUrl: string, title: string, type: string, price: { __typename?: 'Price', amount?: number | null, type?: string | null } } | null> | null } | null };

export type GetHomeFeedQueryVariables = Exact<{
  input: HomeFeedInput;
  homePageMixGroup?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHomeFeedQuery = { __typename?: 'Query', homeFeed?: { __typename?: 'HomeFeed', pageInfo?: { __typename?: 'FeedPageInfo', currentPage?: number | null, numberOfAds?: number | null, hasNextPage?: boolean | null, links?: Array<number | null> | null } | null, results?: Array<{ __typename?: 'BrandedCategoryItem', id: string, imageUrl: string, seoUrl: string, title: string } | { __typename?: 'FeedItem', id: string, imageUrls?: Array<string | null> | null, processorName?: string | null, seoUrl: string, title: string, type: string, price: { __typename?: 'Price', amount?: number | null, type?: string | null } } | { __typename?: 'PopularCategoryItem', id: string, seoUrl: string, title: string } | null> | null } | null };

export type GetHomepageGalleryQueryVariables = Exact<{
  deviceType: Scalars['String']['input'];
  locationId: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  numberOfAds?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHomepageGalleryQuery = { __typename?: 'Query', homepageGallery?: { __typename?: 'HomepageGallery', items?: Array<{ __typename?: 'GalleryItem', id: number, imageAltText?: string | null, imageUrl?: string | null, title: string, seoUrl: string, price?: { __typename?: 'Price', amount?: number | null, type?: string | null } | null } | null> | null } | null };

export type GetPopularKeywordsNearYouQueryVariables = Exact<{
  searchUrlPopularInput: SearchUrlPopularRelatedInput;
}>;


export type GetPopularKeywordsNearYouQuery = { __typename?: 'Query', searchUrlsPopular?: Array<{ __typename?: 'LabeledUrl', label: string, url: string }> | null };

export type GetRecentlyViewedListingsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetRecentlyViewedListingsQuery = { __typename?: 'Query', user?: { __typename?: 'User', recentlyViewedListings?: Array<{ __typename?: 'RecentlyViewedListings', title: string, seoUrl: string, imageUrls?: Array<string | null> | null, id: string, locationId: number, categoryId: number, price: { __typename?: 'Price', amount?: number | null, type?: string | null } } | null> | null } | null };

export type GetRecommendedForYouQueryVariables = Exact<{
  listingIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetRecommendedForYouQuery = { __typename?: 'Query', listingsRecommendedForYou?: Array<{ __typename?: 'CoreListing', id: string, title: string, imageUrls: Array<string>, url: string, price?: { __typename?: 'AutosDealerAmountPrice' } | { __typename?: 'NonAmountPrice' } | { __typename?: 'StandardAmountPrice', amount: number } | null } | null> | null };

export type GetListingQueryVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type GetListingQuery = { __typename?: 'Query', listing?: { __typename?: 'AutosListing', activationDate?: any | null, adSource: AdSource, categoryId: number, description?: string | null, id: string, imageUrls: Array<string>, sortingDate?: any | null, title: string, type: AdType, url: string, views?: number | null, youtubeVideoId?: string | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null }, location: { __typename?: 'ListingLocation', address?: string | null, id: number, name: string, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, sellerType: SellerType, websiteUrl?: string | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null } | { __typename?: 'RealEstateListing', activationDate?: any | null, adSource: AdSource, categoryId: number, description?: string | null, id: string, imageUrls: Array<string>, sortingDate?: any | null, title: string, type: AdType, url: string, views?: number | null, youtubeVideoId?: string | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null }, location: { __typename?: 'ListingLocation', address?: string | null, id: number, name: string, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, sellerType: SellerType, websiteUrl?: string | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null } | { __typename?: 'StandardListing', activationDate?: any | null, adSource: AdSource, categoryId: number, description?: string | null, id: string, imageUrls: Array<string>, sortingDate?: any | null, title: string, type: AdType, url: string, views?: number | null, youtubeVideoId?: string | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null, values: Array<string | null>, name: string } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, highlight?: boolean | null, hpGallery?: boolean | null, topAd?: boolean | null }, location: { __typename?: 'ListingLocation', address?: string | null, id: number, name: string, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string, sellerType: SellerType, websiteUrl?: string | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, currency: string, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, currency: string, originalAmount?: number | null, type: ListingPriceType } | null } | null };

export type ListingReportMutationVariables = Exact<{
  listingReportId: Scalars['ID']['input'];
  reason: Reason;
  email?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListingReportMutation = { __typename?: 'Mutation', listingReport?: null | null };

export type ListingVisitMutationVariables = Exact<{
  listingVisitId: Scalars['ID']['input'];
}>;


export type ListingVisitMutation = { __typename?: 'Mutation', listingVisit?: null | null };

export type VehicleReportQueryVariables = Exact<{
  adId: Scalars['Int']['input'];
  source?: InputMaybe<AdSource>;
}>;


export type VehicleReportQuery = { __typename?: 'Query', ad?: { __typename?: 'MoveAd', vehicleReport?: { __typename?: 'VehicleReport', badgeKeys: Array<string>, reportUrl?: string | null } | null } | { __typename?: 'OrganicAd' } | null };

export type GetGeocodeCanadianAddressQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetGeocodeCanadianAddressQuery = { __typename?: 'Query', geocodeCanadianAddress?: { __typename?: 'GeocodeCanadianAddress', location?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | null };

export type GetGeocodeReverseFromIpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeocodeReverseFromIpQuery = { __typename?: 'Query', geocodeReverseFromIp: { __typename?: 'GeocodeReverseFromIp', city?: string | null, province: ProvinceAbbreviation, locationId?: number | null } };

export type GetLocationFromCoordinatesQueryVariables = Exact<{
  coordinates: LocationQueryCoordsOptions;
}>;


export type GetLocationFromCoordinatesQuery = { __typename?: 'Query', locationFromCoordinates?: { __typename?: 'LocationWithPlace', location?: { __typename?: 'Location', id: number, locationPaths?: Array<{ __typename?: 'Location', id: number }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null, place?: { __typename?: 'PlaceDetails', address?: string | null, location?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null, postalCode?: { __typename?: 'AddressFormat', long: string } | null } | null } | null };

export type GetLocationFromIdQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetLocationFromIdQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: number, localizedName?: string | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null } | null };

export type GetLocationFromPlaceQueryVariables = Exact<{
  placeId: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLocationFromPlaceQuery = { __typename?: 'Query', locationFromPlace?: { __typename?: 'LocationWithPlace', place?: { __typename?: 'PlaceDetails', id?: string | null, address?: string | null, isCountry: boolean, isProvince: boolean, location?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null, postalCode?: { __typename?: 'AddressFormat', long: string, short: string } | null } | null, location?: { __typename?: 'Location', id: number, coordinates?: { __typename?: 'LocationCoordinates', latitude: number, longitude: number } | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null } | null };

export type GetLocationPathFromIdQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetLocationPathFromIdQuery = { __typename?: 'Query', location?: { __typename?: 'Location', locationPaths?: Array<{ __typename?: 'Location', id: number, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null }> | null } | null };

export type SocialLinksFieldsFragment = { __typename?: 'PersonalAccount', socialLinks?: { __typename?: 'AccountSocialLinks', facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null, tiktok?: string | null, pinterest?: string | null, linkedin?: string | null } | null };

export type GetSocialLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSocialLinksQuery = { __typename?: 'Query', myAccount?: { __typename?: 'PersonalAccount', socialLinks?: { __typename?: 'AccountSocialLinks', facebook?: string | null, instagram?: string | null, twitter?: string | null, youtube?: string | null, tiktok?: string | null, pinterest?: string | null, linkedin?: string | null } | null } | null };

export type UpdateSocialLinksMutationVariables = Exact<{
  input: UpdateSocialLinksInput;
}>;


export type UpdateSocialLinksMutation = { __typename?: 'Mutation', updateSocialLinks?: { __typename?: 'StatusResponse', statusCode?: number | null } | null };

export type AddFavouriteListingMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type AddFavouriteListingMutation = { __typename?: 'Mutation', addFavouriteListing: string };

export type GetAuthModalStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthModalStateQuery = { __typename?: 'Query', authModalState: { __typename?: 'AuthModalState', isModalOpen: boolean, modalVariant?: AuthModalVariant | null, callbackUrl?: string | null } };

export type AttributeFilterFieldsFragment = { __typename: 'AttributeFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null };

export type DateFilterFieldsFragment = { __typename: 'DateFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, selectedValue?: string | null };

export type RangeFilterFieldsFragment = { __typename: 'RangeFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null };

export type ToggleFilterFieldsFragment = { __typename: 'ToggleFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, trueValue: string, isSelected: boolean };

export type CoreSrpFragment = { __typename?: 'SearchResultsPage', controls: { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValue?: string | null } | { __typename: 'RangeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, trueValue: string, isSelected: boolean }> }>, sorting: Array<{ __typename?: 'SortOption', by: SrpSortBy, direction: SortDirection, label: string, isSelected: boolean }> }, pagination: { __typename?: 'Pagination', offset: number, limit: number, totalCount: number }, results?: { __typename?: 'SearchResults', topListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }>, mainListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }> } | null };

export type CoreSearchQueryFragment = { __typename?: 'SearchQuery', keywords?: string | null, seoUrl?: string | null, searchString: string, area?: { __typename?: 'LocationArea', address?: string | null, latitude: number, longitude: number, radius: number } | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null, location?: { __typename?: 'Location', id: number, localizedName?: string | null, locationPaths?: Array<{ __typename?: 'Location', id: number, localizedName?: string | null }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null };

export type GetSeoUrlQueryVariables = Exact<{
  input: SearchUrlInput;
}>;


export type GetSeoUrlQuery = { __typename?: 'Query', searchUrl?: string | null };

export type GetSearchResultsPageByUrlQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
}>;


export type GetSearchResultsPageByUrlQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', searchQuery: { __typename?: 'SearchQuery', keywords?: string | null, seoUrl?: string | null, searchString: string, filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', flags: Array<AdditionalFlags>, filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, filterName: string } | { __typename?: 'AppliedDateRangeFilter', start?: string | null, end?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', minValue?: number | null, maxValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }>, area?: { __typename?: 'LocationArea', address?: string | null, latitude: number, longitude: number, radius: number } | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null, location?: { __typename?: 'Location', id: number, localizedName?: string | null, locationPaths?: Array<{ __typename?: 'Location', id: number, localizedName?: string | null }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null }, controls: { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValue?: string | null } | { __typename: 'RangeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, trueValue: string, isSelected: boolean }> }>, sorting: Array<{ __typename?: 'SortOption', by: SrpSortBy, direction: SortDirection, label: string, isSelected: boolean }> }, pagination: { __typename?: 'Pagination', offset: number, limit: number, totalCount: number }, results?: { __typename?: 'SearchResults', topListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }>, mainListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }> } | null } };

export type GetSearchResultsPageByUrlWithSeoQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
  searchUrlPopularInput: SearchUrlPopularRelatedInput;
}>;


export type GetSearchResultsPageByUrlWithSeoQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', searchQuery: { __typename?: 'SearchQuery', keywords?: string | null, seoUrl?: string | null, searchString: string, filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', flags: Array<AdditionalFlags>, filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, filterName: string } | { __typename?: 'AppliedDateRangeFilter', start?: string | null, end?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', minValue?: number | null, maxValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }>, area?: { __typename?: 'LocationArea', address?: string | null, latitude: number, longitude: number, radius: number } | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null, location?: { __typename?: 'Location', id: number, localizedName?: string | null, locationPaths?: Array<{ __typename?: 'Location', id: number, localizedName?: string | null }> | null, name?: { __typename?: 'Locale', en_CA?: string | null, fr_CA?: string | null } | null } | null }, controls: { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, selectedValue?: string | null } | { __typename: 'RangeFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', name: string, type: FilterControlType, label: string, parentName?: string | null, trueValue: string, isSelected: boolean }> }>, sorting: Array<{ __typename?: 'SortOption', by: SrpSortBy, direction: SortDirection, label: string, isSelected: boolean }> }, pagination: { __typename?: 'Pagination', offset: number, limit: number, totalCount: number }, results?: { __typename?: 'SearchResults', topListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }>, mainListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }> } | null }, searchUrlsPopular?: Array<{ __typename?: 'LabeledUrl', label: string, url: string }> | null };

export type GetAppliedFiltersQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
}>;


export type GetAppliedFiltersQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', searchQuery: { __typename?: 'SearchQuery', filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, filterName: string } | { __typename?: 'AppliedDateRangeFilter', end?: string | null, start?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', maxValue?: number | null, minValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }> }, pagination: { __typename?: 'Pagination', totalCount: number } } };

export type BreadcrumbsSearchQueryFragment = { __typename?: 'SearchQuery', keywords?: string | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null };

export type GetBreadcrumbsBySearchPageUrlQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
}>;


export type GetBreadcrumbsBySearchPageUrlQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', searchQuery: { __typename?: 'SearchQuery', keywords?: string | null, category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, searchSeoUrl?: string | null } | null> | null } | null } } };

export type GetCategoriesQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type GetCategoriesQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null, categoryPaths?: Array<{ __typename?: 'Category', id: number, localizedName?: string | null, parentId?: number | null } | null> | null, attributes?: Array<{ __typename?: 'Attribute', id: number, canonicalName?: string | null, localizedFields?: Array<{ __typename?: 'AttributeFields', canonicalValue?: string | null, seoSlug?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type GetUserFavouritesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFavouritesListQuery = { __typename?: 'Query', favouriteListingsIds: Array<string> };

export type GetFilterDrawerStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFilterDrawerStateQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', isFilterDrawerOpen: boolean, selectedAccordionItems?: Array<string> | null } };

export type GetOrganicListingsQueryVariables = Exact<{
  input: SearchResultsInput;
}>;


export type GetOrganicListingsQuery = { __typename?: 'Query', searchResultsPageUpdate: { __typename?: 'SearchResultsPage', results?: { __typename?: 'SearchResults', mainListings: Array<{ __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } } | { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } }> } | null } };

export type GetPopularRelatedKeywordsQueryVariables = Exact<{
  searchUrlPopularInput: SearchUrlPopularRelatedInput;
}>;


export type GetPopularRelatedKeywordsQuery = { __typename?: 'Query', searchUrlsPopular?: Array<{ __typename?: 'LabeledUrl', label: string, url: string }> | null };

export type GetSearchFiltersQueryVariables = Exact<{
  searchResultsByUrlInput: SearchResultsByUrlInput;
}>;


export type GetSearchFiltersQuery = { __typename?: 'Query', searchResultsPageByUrl: { __typename?: 'SearchResultsPage', controls: { __typename?: 'SearchControls', filtering: Array<{ __typename?: 'FilterGroup', name: string, label?: string | null, shouldShowTopLevelAccordion?: boolean | null, quickFilterSortOrder?: number | null, filters: Array<{ __typename: 'AttributeFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, selectedValues?: Array<string> | null, values?: Array<{ __typename?: 'AttributeValue', label: string, value: string, totalResults?: number | null, parentValue?: string | null, seoUrl?: string | null }> | null } | { __typename: 'DateFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, selectedValue?: string | null } | { __typename: 'RangeFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, fromRange: { __typename?: 'MinMax', min: number, max?: number | null }, toRange: { __typename?: 'MinMax', min: number, max?: number | null }, rangeLabels: { __typename?: 'RangeLabels', from: string, to: string }, selectedRangeValues?: { __typename: 'MinMax', min: number, max?: number | null } | { __typename: 'StartEndDate', start?: string | null, end?: string | null } | null } | { __typename: 'ToggleFilter', type: FilterControlType, name: string, parentName?: string | null, label: string, trueValue: string, isSelected: boolean }> }> }, searchQuery: { __typename?: 'SearchQuery', category?: { __typename?: 'Category', id: number } | null, filters: Array<{ __typename?: 'AppliedAdditionalFlagsFilter', flags: Array<AdditionalFlags>, filterName: string } | { __typename?: 'AppliedAttributeFilter', values: Array<string>, filterName: string } | { __typename?: 'AppliedDateFilter', value: string, filterName: string } | { __typename?: 'AppliedDateRangeFilter', start?: string | null, end?: string | null, filterName: string } | { __typename?: 'AppliedRangeFilter', minValue?: number | null, maxValue?: number | null, filterName: string } | { __typename?: 'AppliedToggleFilter', toggleValue: string, filterName: string }> } } };

export type GetSearchUrlQueryVariables = Exact<{
  input: SearchUrlInput;
}>;


export type GetSearchUrlQuery = { __typename?: 'Query', searchUrl?: string | null };

export type GetSearchLoadingStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchLoadingStateQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', loadingFilters: boolean, loadingResults: boolean } };

export type GetPendingSearchInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingSearchInputQuery = { __typename?: 'Query', srp: { __typename?: 'SearchResultsPageState', pendingSearchInput?: { __typename?: 'PendingSearchInput', keywords?: string | null, by?: SrpSortBy | null, direction?: SortDirection | null, offset?: number | null, additionalFlagFilters?: Array<AdditionalFlags> | null, attributeFilters?: Array<{ __typename?: 'AppliedAttributeFilter', filterName: string, values: Array<string> }> | null, rangeFilters?: Array<{ __typename?: 'AppliedRangeFilter', filterName: string, minValue?: number | null, maxValue?: number | null }> | null, dateRangeFilters?: Array<{ __typename?: 'AppliedDateRangeFilter', filterName: string, start?: string | null, end?: string | null }> | null, dateFilters?: Array<{ __typename?: 'AppliedDateFilter', filterName: string, value: string }> | null, toggleFilters?: Array<{ __typename?: 'AppliedToggleFilter', filterName: string, toggleValue: string }> | null } | null } };

export type GetVipUrlQueryVariables = Exact<{
  adId: Scalars['ID']['input'];
}>;


export type GetVipUrlQuery = { __typename?: 'Query', listingUrl: string };

type Listing_AutosListing_Fragment = { __typename?: 'AutosListing', moveUrl?: string | null, id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } };

type Listing_RealEstateListing_Fragment = { __typename?: 'RealEstateListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes: { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null }, flags: { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } };

type Listing_StandardListing_Fragment = { __typename?: 'StandardListing', id: string, title: string, description?: string | null, imageUrls: Array<string>, categoryId: number, url: string, activationDate?: any | null, sortingDate?: any | null, adSource: AdSource, location: { __typename?: 'ListingLocation', id: number, name: string, address?: string | null, distance?: number | null, nearestIntersection?: Array<string> | null }, price?: { __typename?: 'AutosDealerAmountPrice', amount: number, originalAmount?: number | null, msrp?: number | null, surcharges: AutosSurcharges, type: ListingPriceType } | { __typename?: 'NonAmountPrice', type: ListingPriceType } | { __typename?: 'StandardAmountPrice', amount: number, originalAmount?: number | null, type: ListingPriceType } | null, attributes?: { __typename?: 'AutosListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'RealEstateListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | { __typename?: 'StandardListingAttributes', all?: Array<{ __typename?: 'ListingAttributeV2', canonicalName: string, canonicalValues?: Array<string> | null } | null> | null } | null, flags: { __typename?: 'AutosListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'RealEstateListingFlags', virtualTour?: boolean | null, categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null } | { __typename?: 'StandardListingFlags', categorySpecificBadge?: boolean | null, priceDrop?: boolean | null, showcase?: boolean | null, topAd?: boolean | null, highlight?: boolean | null, shippedBySeller?: boolean | null, isPromotionProvTopAd?: boolean | null, isPromotionTopAd?: boolean | null }, posterInfo: { __typename?: 'PosterInfo', posterId: string } };

export type ListingFragment = Listing_AutosListing_Fragment | Listing_RealEstateListing_Fragment | Listing_StandardListing_Fragment;

export type OneTimeSavedSearchMutationVariables = Exact<{
  input: OneTimeSavedSearchInput;
}>;


export type OneTimeSavedSearchMutation = { __typename?: 'Mutation', oneTimeSavedSearch: number };

export type RemoveFavouriteListingMutationVariables = Exact<{
  listingId: Scalars['ID']['input'];
}>;


export type RemoveFavouriteListingMutation = { __typename?: 'Mutation', removeFavouriteListing: string };

export const PersonalInformationFieldsFragmentDoc = gql`
    fragment PersonalInformationFields on PersonalAccount {
  accountType
  id
  name
  email
  address
  profileUrl
  phoneNumber
}
    `;
export const SocialLinksFieldsFragmentDoc = gql`
    fragment SocialLinksFields on PersonalAccount {
  socialLinks {
    facebook
    instagram
    twitter
    youtube
    tiktok
    pinterest
    linkedin
  }
}
    `;
export const AttributeFilterFieldsFragmentDoc = gql`
    fragment AttributeFilterFields on AttributeFilter {
  __typename
  type
  name
  parentName
  label
  values {
    label
    value
    totalResults
    parentValue
    seoUrl
  }
  selectedValues
}
    `;
export const RangeFilterFieldsFragmentDoc = gql`
    fragment RangeFilterFields on RangeFilter {
  __typename
  type
  name
  parentName
  label
  fromRange {
    min
    max
  }
  toRange {
    min
    max
  }
  rangeLabels {
    from
    to
  }
  selectedRangeValues {
    __typename
    ... on MinMax {
      __typename
      min
      max
    }
    ... on StartEndDate {
      __typename
      start
      end
    }
  }
}
    `;
export const DateFilterFieldsFragmentDoc = gql`
    fragment DateFilterFields on DateFilter {
  __typename
  type
  name
  parentName
  label
  selectedValue
}
    `;
export const ToggleFilterFieldsFragmentDoc = gql`
    fragment ToggleFilterFields on ToggleFilter {
  __typename
  type
  name
  parentName
  label
  trueValue
  isSelected
}
    `;
export const CoreSrpFragmentDoc = gql`
    fragment CoreSRP on SearchResultsPage {
  controls {
    filtering {
      name
      label
      shouldShowTopLevelAccordion
      quickFilterSortOrder
      filters {
        __typename
        name
        type
        label
        parentName
        ... on AttributeFilter {
          ...AttributeFilterFields
        }
        ... on RangeFilter {
          ...RangeFilterFields
        }
        ... on DateFilter {
          ...DateFilterFields
        }
        ... on ToggleFilter {
          ...ToggleFilterFields
        }
      }
    }
    sorting {
      by
      direction
      label
      isSelected
    }
  }
  pagination {
    offset
    limit
    totalCount
  }
  results {
    topListings {
      id
      title
      description
      imageUrls
      categoryId
      url
      activationDate
      sortingDate
      adSource
      location {
        id
        name
        address
        distance
        nearestIntersection
      }
      price {
        type
        ... on StandardAmountPrice {
          amount
          originalAmount
        }
        ... on AutosDealerAmountPrice {
          amount
          originalAmount
          msrp
          surcharges
        }
      }
      attributes {
        all {
          canonicalName
          canonicalValues
        }
      }
      flags {
        categorySpecificBadge
        priceDrop
        showcase
        topAd
        highlight
        shippedBySeller
        isPromotionProvTopAd
        isPromotionTopAd
        ... on RealEstateListingFlags {
          virtualTour
        }
      }
      posterInfo {
        posterId
      }
      ... on AutosListing {
        moveUrl
      }
    }
    mainListings {
      id
      title
      description
      imageUrls
      categoryId
      url
      activationDate
      sortingDate
      adSource
      location {
        id
        name
        address
        distance
        nearestIntersection
      }
      price {
        type
        ... on StandardAmountPrice {
          amount
          originalAmount
        }
        ... on AutosDealerAmountPrice {
          amount
          originalAmount
          msrp
          surcharges
        }
      }
      attributes {
        all {
          canonicalName
          canonicalValues
        }
      }
      flags {
        categorySpecificBadge
        priceDrop
        showcase
        topAd
        highlight
        shippedBySeller
        isPromotionProvTopAd
        isPromotionTopAd
        ... on RealEstateListingFlags {
          virtualTour
        }
      }
      posterInfo {
        posterId
      }
      ... on AutosListing {
        moveUrl
      }
    }
  }
}
    ${AttributeFilterFieldsFragmentDoc}
${RangeFilterFieldsFragmentDoc}
${DateFilterFieldsFragmentDoc}
${ToggleFilterFieldsFragmentDoc}`;
export const CoreSearchQueryFragmentDoc = gql`
    fragment CoreSearchQuery on SearchQuery {
  area {
    address
    latitude
    longitude
    radius
  }
  category {
    id
    localizedName
    parentId
    searchSeoUrl
    categoryPaths {
      id
      localizedName
      parentId
      searchSeoUrl
    }
  }
  keywords
  location {
    id
    localizedName
    locationPaths {
      id
      localizedName
    }
    name {
      en_CA
      fr_CA
    }
  }
  seoUrl
  searchString
}
    `;
export const BreadcrumbsSearchQueryFragmentDoc = gql`
    fragment BreadcrumbsSearchQuery on SearchQuery {
  category {
    id
    localizedName
    parentId
    searchSeoUrl
    categoryPaths {
      id
      localizedName
      parentId
      searchSeoUrl
    }
  }
  keywords
}
    `;
export const ListingFragmentDoc = gql`
    fragment Listing on FullListing {
  id
  title
  description
  imageUrls
  categoryId
  url
  activationDate
  sortingDate
  adSource
  location {
    id
    name
    address
    distance
    nearestIntersection
  }
  price {
    type
    ... on AmountPrice {
      amount
      originalAmount
    }
    ... on AutosDealerAmountPrice {
      amount
      originalAmount
      msrp
      surcharges
    }
  }
  attributes {
    all {
      canonicalName
      canonicalValues
    }
  }
  flags {
    categorySpecificBadge
    priceDrop
    showcase
    topAd
    highlight
    shippedBySeller
    isPromotionProvTopAd
    isPromotionTopAd
    ... on RealEstateListingFlags {
      virtualTour
    }
  }
  posterInfo {
    posterId
  }
  ... on AutosListing {
    moveUrl
  }
}
    `;
export const NotificationsDocument = gql`
    query Notifications($userId: Int!) {
  notifications(userId: $userId) {
    notifications {
      title
      body
      dateCreated
      destinationUrl
      id
      pictureUrl
      read
      type
    }
    newCount
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const GetUnreadNotificationDataDocument = gql`
    query GetUnreadNotificationData {
  unreadConversationsCount
  unreadNotificationsCount
}
    `;

/**
 * __useGetUnreadNotificationDataQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>(GetUnreadNotificationDataDocument, options);
      }
export function useGetUnreadNotificationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>(GetUnreadNotificationDataDocument, options);
        }
export type GetUnreadNotificationDataQueryHookResult = ReturnType<typeof useGetUnreadNotificationDataQuery>;
export type GetUnreadNotificationDataLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationDataLazyQuery>;
export type GetUnreadNotificationDataQueryResult = Apollo.QueryResult<GetUnreadNotificationDataQuery, GetUnreadNotificationDataQueryVariables>;
export const ChangePasswordViaResetLinkDocument = gql`
    mutation changePasswordViaResetLink($password: String!, $token: UUID!) {
  changePasswordViaResetLink(password: $password, token: $token)
}
    `;
export type ChangePasswordViaResetLinkMutationFn = Apollo.MutationFunction<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>;

/**
 * __useChangePasswordViaResetLinkMutation__
 *
 * To run a mutation, you first call `useChangePasswordViaResetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordViaResetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordViaResetLinkMutation, { data, loading, error }] = useChangePasswordViaResetLinkMutation({
 *   variables: {
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useChangePasswordViaResetLinkMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>(ChangePasswordViaResetLinkDocument, options);
      }
export type ChangePasswordViaResetLinkMutationHookResult = ReturnType<typeof useChangePasswordViaResetLinkMutation>;
export type ChangePasswordViaResetLinkMutationResult = Apollo.MutationResult<ChangePasswordViaResetLinkMutation>;
export type ChangePasswordViaResetLinkMutationOptions = Apollo.BaseMutationOptions<ChangePasswordViaResetLinkMutation, ChangePasswordViaResetLinkMutationVariables>;
export const GenerateXsrfDocument = gql`
    mutation generateXsrf {
  generateXsrf {
    message
    statusCode
    xsrf
  }
}
    `;
export type GenerateXsrfMutationFn = Apollo.MutationFunction<GenerateXsrfMutation, GenerateXsrfMutationVariables>;

/**
 * __useGenerateXsrfMutation__
 *
 * To run a mutation, you first call `useGenerateXsrfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateXsrfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateXsrfMutation, { data, loading, error }] = useGenerateXsrfMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateXsrfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateXsrfMutation, GenerateXsrfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateXsrfMutation, GenerateXsrfMutationVariables>(GenerateXsrfDocument, options);
      }
export type GenerateXsrfMutationHookResult = ReturnType<typeof useGenerateXsrfMutation>;
export type GenerateXsrfMutationResult = Apollo.MutationResult<GenerateXsrfMutation>;
export type GenerateXsrfMutationOptions = Apollo.BaseMutationOptions<GenerateXsrfMutation, GenerateXsrfMutationVariables>;
export const LogoutUserDocument = gql`
    mutation logoutUser($input: LogoutUserInput!) {
  logoutUser(input: $input) {
    message
    statusCode
  }
}
    `;
export type LogoutUserMutationFn = Apollo.MutationFunction<LogoutUserMutation, LogoutUserMutationVariables>;

/**
 * __useLogoutUserMutation__
 *
 * To run a mutation, you first call `useLogoutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserMutation, { data, loading, error }] = useLogoutUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogoutUserMutation(baseOptions?: Apollo.MutationHookOptions<LogoutUserMutation, LogoutUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutUserMutation, LogoutUserMutationVariables>(LogoutUserDocument, options);
      }
export type LogoutUserMutationHookResult = ReturnType<typeof useLogoutUserMutation>;
export type LogoutUserMutationResult = Apollo.MutationResult<LogoutUserMutation>;
export type LogoutUserMutationOptions = Apollo.BaseMutationOptions<LogoutUserMutation, LogoutUserMutationVariables>;
export const RequestPasswordResetLinkDocument = gql`
    mutation requestPasswordResetLink($input: RequestPasswordResetLinkInput!) {
  requestPasswordResetLink(input: $input)
}
    `;
export type RequestPasswordResetLinkMutationFn = Apollo.MutationFunction<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>;

/**
 * __useRequestPasswordResetLinkMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetLinkMutation, { data, loading, error }] = useRequestPasswordResetLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>(RequestPasswordResetLinkDocument, options);
      }
export type RequestPasswordResetLinkMutationHookResult = ReturnType<typeof useRequestPasswordResetLinkMutation>;
export type RequestPasswordResetLinkMutationResult = Apollo.MutationResult<RequestPasswordResetLinkMutation>;
export type RequestPasswordResetLinkMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetLinkMutation, RequestPasswordResetLinkMutationVariables>;
export const RegisterUserDocument = gql`
    mutation registerUser($input: UserRegistrationInput!) {
  userRegistration(input: $input)
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const GetListingsSimilarDocument = gql`
    query GetListingsSimilar($listingId: ID!, $limit: Int) {
  listingsSimilar(listingId: $listingId, limit: $limit) {
    categoryId
    id
    imageUrls
    title
    url
    location {
      name
    }
    price {
      type
      ... on StandardAmountPrice {
        amount
      }
      ... on AutosDealerAmountPrice {
        amount
      }
    }
  }
}
    `;

/**
 * __useGetListingsSimilarQuery__
 *
 * To run a query within a React component, call `useGetListingsSimilarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingsSimilarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingsSimilarQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetListingsSimilarQuery(baseOptions: Apollo.QueryHookOptions<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>(GetListingsSimilarDocument, options);
      }
export function useGetListingsSimilarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>(GetListingsSimilarDocument, options);
        }
export type GetListingsSimilarQueryHookResult = ReturnType<typeof useGetListingsSimilarQuery>;
export type GetListingsSimilarLazyQueryHookResult = ReturnType<typeof useGetListingsSimilarLazyQuery>;
export type GetListingsSimilarQueryResult = Apollo.QueryResult<GetListingsSimilarQuery, GetListingsSimilarQueryVariables>;
export const GetMenuPrefetchDocument = gql`
    query GetMenuPrefetch($locationId: Int!, $categoryId: Int, $locale: String, $depth: Int, $hints: [Hints]) {
  menuPrefetch(
    locationId: $locationId
    categoryId: $categoryId
    locale: $locale
    depth: $depth
    hints: $hints
  ) {
    id
    categoryName
    isLeaf
    seoUrl
    children {
      categoryName
      seoUrl
      isLeaf
      id
      children {
        categoryName
        id
        isLeaf
        seoUrl
      }
    }
  }
}
    `;

/**
 * __useGetMenuPrefetchQuery__
 *
 * To run a query within a React component, call `useGetMenuPrefetchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMenuPrefetchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMenuPrefetchQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      categoryId: // value for 'categoryId'
 *      locale: // value for 'locale'
 *      depth: // value for 'depth'
 *      hints: // value for 'hints'
 *   },
 * });
 */
export function useGetMenuPrefetchQuery(baseOptions: Apollo.QueryHookOptions<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>(GetMenuPrefetchDocument, options);
      }
export function useGetMenuPrefetchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>(GetMenuPrefetchDocument, options);
        }
export type GetMenuPrefetchQueryHookResult = ReturnType<typeof useGetMenuPrefetchQuery>;
export type GetMenuPrefetchLazyQueryHookResult = ReturnType<typeof useGetMenuPrefetchLazyQuery>;
export type GetMenuPrefetchQueryResult = Apollo.QueryResult<GetMenuPrefetchQuery, GetMenuPrefetchQueryVariables>;
export const GetProfileDocument = gql`
    query GetProfile($profileId: ID!, $size: LogoType!) {
  profile(id: $profileId) {
    id
    name
    numberOfListings
    userType
    ... on StandardProfileV2 {
      imageUrl
      isSalesforceEnabled
    }
    ... on CommercialProfileV2 {
      logoUrl(size: $size)
      phoneNumber
      staticMapUrl
      websiteUrl
    }
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetReviewSummaryDocument = gql`
    query GetReviewSummary($userId: Int!) {
  reviewSummary(userId: $userId) {
    sumScore
    totalReviews
  }
}
    `;

/**
 * __useGetReviewSummaryQuery__
 *
 * To run a query within a React component, call `useGetReviewSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReviewSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>(GetReviewSummaryDocument, options);
      }
export function useGetReviewSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>(GetReviewSummaryDocument, options);
        }
export type GetReviewSummaryQueryHookResult = ReturnType<typeof useGetReviewSummaryQuery>;
export type GetReviewSummaryLazyQueryHookResult = ReturnType<typeof useGetReviewSummaryLazyQuery>;
export type GetReviewSummaryQueryResult = Apollo.QueryResult<GetReviewSummaryQuery, GetReviewSummaryQueryVariables>;
export const GetCategoryNameDocument = gql`
    query GetCategoryName($categoryId: Int!) {
  category(id: $categoryId) {
    id
    localizedName
  }
}
    `;

/**
 * __useGetCategoryNameQuery__
 *
 * To run a query within a React component, call `useGetCategoryNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryNameQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetCategoryNameQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryNameQuery, GetCategoryNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryNameQuery, GetCategoryNameQueryVariables>(GetCategoryNameDocument, options);
      }
export function useGetCategoryNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryNameQuery, GetCategoryNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryNameQuery, GetCategoryNameQueryVariables>(GetCategoryNameDocument, options);
        }
export type GetCategoryNameQueryHookResult = ReturnType<typeof useGetCategoryNameQuery>;
export type GetCategoryNameLazyQueryHookResult = ReturnType<typeof useGetCategoryNameLazyQuery>;
export type GetCategoryNameQueryResult = Apollo.QueryResult<GetCategoryNameQuery, GetCategoryNameQueryVariables>;
export const GetProfileMetricsDocument = gql`
    query GetProfileMetrics($profileId: ID!) {
  profile(id: $profileId) {
    id
    ... on StandardProfileV2 {
      memberSince
      replyRate
      responsiveness
    }
  }
}
    `;

/**
 * __useGetProfileMetricsQuery__
 *
 * To run a query within a React component, call `useGetProfileMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMetricsQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetProfileMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>(GetProfileMetricsDocument, options);
      }
export function useGetProfileMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>(GetProfileMetricsDocument, options);
        }
export type GetProfileMetricsQueryHookResult = ReturnType<typeof useGetProfileMetricsQuery>;
export type GetProfileMetricsLazyQueryHookResult = ReturnType<typeof useGetProfileMetricsLazyQuery>;
export type GetProfileMetricsQueryResult = Apollo.QueryResult<GetProfileMetricsQuery, GetProfileMetricsQueryVariables>;
export const MyAccountDocument = gql`
    query myAccount {
  myAccount {
    ...PersonalInformationFields
  }
}
    ${PersonalInformationFieldsFragmentDoc}`;

/**
 * __useMyAccountQuery__
 *
 * To run a query within a React component, call `useMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
      }
export function useMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export type MyAccountQueryHookResult = ReturnType<typeof useMyAccountQuery>;
export type MyAccountLazyQueryHookResult = ReturnType<typeof useMyAccountLazyQuery>;
export type MyAccountQueryResult = Apollo.QueryResult<MyAccountQuery, MyAccountQueryVariables>;
export const GetAlgoliaKeyDocument = gql`
    mutation GetAlgoliaKey {
  getAlgoliaKey
}
    `;
export type GetAlgoliaKeyMutationFn = Apollo.MutationFunction<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>;

/**
 * __useGetAlgoliaKeyMutation__
 *
 * To run a mutation, you first call `useGetAlgoliaKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAlgoliaKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAlgoliaKeyMutation, { data, loading, error }] = useGetAlgoliaKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetAlgoliaKeyMutation(baseOptions?: Apollo.MutationHookOptions<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>(GetAlgoliaKeyDocument, options);
      }
export type GetAlgoliaKeyMutationHookResult = ReturnType<typeof useGetAlgoliaKeyMutation>;
export type GetAlgoliaKeyMutationResult = Apollo.MutationResult<GetAlgoliaKeyMutation>;
export type GetAlgoliaKeyMutationOptions = Apollo.BaseMutationOptions<GetAlgoliaKeyMutation, GetAlgoliaKeyMutationVariables>;
export const GetCampaignsDocument = gql`
    query getCampaigns($placement: String!, $customType: String!, $locationId: Int!, $categoryId: Int!, $platform: String!, $filterAmount: Int) {
  campaigns(
    placement: $placement
    customType: $customType
    locationId: $locationId
    categoryId: $categoryId
    platform: $platform
    filterAmount: $filterAmount
  ) {
    customFields
    id
  }
}
    `;

/**
 * __useGetCampaignsQuery__
 *
 * To run a query within a React component, call `useGetCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsQuery({
 *   variables: {
 *      placement: // value for 'placement'
 *      customType: // value for 'customType'
 *      locationId: // value for 'locationId'
 *      categoryId: // value for 'categoryId'
 *      platform: // value for 'platform'
 *      filterAmount: // value for 'filterAmount'
 *   },
 * });
 */
export function useGetCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
      }
export function useGetCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsQuery, GetCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsQuery, GetCampaignsQueryVariables>(GetCampaignsDocument, options);
        }
export type GetCampaignsQueryHookResult = ReturnType<typeof useGetCampaignsQuery>;
export type GetCampaignsLazyQueryHookResult = ReturnType<typeof useGetCampaignsLazyQuery>;
export type GetCampaignsQueryResult = Apollo.QueryResult<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetCategoryPathDocument = gql`
    query GetCategoryPath($categoryId: Int!, $locale: String, $locationId: Int) {
  category(id: $categoryId) {
    id
    localizedName(locale: $locale)
    parentId
    searchSeoUrl(locationId: $locationId)
    categoryPaths {
      id
      localizedName(locale: $locale)
      parentId
      searchSeoUrl(locationId: $locationId)
    }
  }
}
    `;

/**
 * __useGetCategoryPathQuery__
 *
 * To run a query within a React component, call `useGetCategoryPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryPathQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      locale: // value for 'locale'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetCategoryPathQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryPathQuery, GetCategoryPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryPathQuery, GetCategoryPathQueryVariables>(GetCategoryPathDocument, options);
      }
export function useGetCategoryPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryPathQuery, GetCategoryPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryPathQuery, GetCategoryPathQueryVariables>(GetCategoryPathDocument, options);
        }
export type GetCategoryPathQueryHookResult = ReturnType<typeof useGetCategoryPathQuery>;
export type GetCategoryPathLazyQueryHookResult = ReturnType<typeof useGetCategoryPathLazyQuery>;
export type GetCategoryPathQueryResult = Apollo.QueryResult<GetCategoryPathQuery, GetCategoryPathQueryVariables>;
export const GetHomeFeedAdsDocument = gql`
    query GetHomeFeedAds {
  homeFeedAds @client {
    adSlots
  }
}
    `;

/**
 * __useGetHomeFeedAdsQuery__
 *
 * To run a query within a React component, call `useGetHomeFeedAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeFeedAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeFeedAdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHomeFeedAdsQuery(baseOptions?: Apollo.QueryHookOptions<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>(GetHomeFeedAdsDocument, options);
      }
export function useGetHomeFeedAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>(GetHomeFeedAdsDocument, options);
        }
export type GetHomeFeedAdsQueryHookResult = ReturnType<typeof useGetHomeFeedAdsQuery>;
export type GetHomeFeedAdsLazyQueryHookResult = ReturnType<typeof useGetHomeFeedAdsLazyQuery>;
export type GetHomeFeedAdsQueryResult = Apollo.QueryResult<GetHomeFeedAdsQuery, GetHomeFeedAdsQueryVariables>;
export const GetPsaDismissedDocument = gql`
    query GetPSADismissed {
  dismissedStates @client {
    appDownloadPSA
    siteMaintenancePSA_may7th
  }
}
    `;

/**
 * __useGetPsaDismissedQuery__
 *
 * To run a query within a React component, call `useGetPsaDismissedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPsaDismissedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPsaDismissedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPsaDismissedQuery(baseOptions?: Apollo.QueryHookOptions<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>(GetPsaDismissedDocument, options);
      }
export function useGetPsaDismissedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>(GetPsaDismissedDocument, options);
        }
export type GetPsaDismissedQueryHookResult = ReturnType<typeof useGetPsaDismissedQuery>;
export type GetPsaDismissedLazyQueryHookResult = ReturnType<typeof useGetPsaDismissedLazyQuery>;
export type GetPsaDismissedQueryResult = Apollo.QueryResult<GetPsaDismissedQuery, GetPsaDismissedQueryVariables>;
export const GetSearchCategoryDocument = gql`
    query GetSearchCategory {
  srp @client {
    searchCategory {
      id
      isDomCat
      localizedName
      name {
        en_CA
        fr_CA
      }
      parentId
      path {
        id
        localizedName
        parentId
        seoUrl
      }
      seoUrl
    }
  }
}
    `;

/**
 * __useGetSearchCategoryQuery__
 *
 * To run a query within a React component, call `useGetSearchCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>(GetSearchCategoryDocument, options);
      }
export function useGetSearchCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>(GetSearchCategoryDocument, options);
        }
export type GetSearchCategoryQueryHookResult = ReturnType<typeof useGetSearchCategoryQuery>;
export type GetSearchCategoryLazyQueryHookResult = ReturnType<typeof useGetSearchCategoryLazyQuery>;
export type GetSearchCategoryQueryResult = Apollo.QueryResult<GetSearchCategoryQuery, GetSearchCategoryQueryVariables>;
export const GetSearchKeywordDocument = gql`
    query GetSearchKeyword {
  srp @client {
    searchKeyword
  }
}
    `;

/**
 * __useGetSearchKeywordQuery__
 *
 * To run a query within a React component, call `useGetSearchKeywordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchKeywordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchKeywordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchKeywordQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>(GetSearchKeywordDocument, options);
      }
export function useGetSearchKeywordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>(GetSearchKeywordDocument, options);
        }
export type GetSearchKeywordQueryHookResult = ReturnType<typeof useGetSearchKeywordQuery>;
export type GetSearchKeywordLazyQueryHookResult = ReturnType<typeof useGetSearchKeywordLazyQuery>;
export type GetSearchKeywordQueryResult = Apollo.QueryResult<GetSearchKeywordQuery, GetSearchKeywordQueryVariables>;
export const GetUserAuthStateDocument = gql`
    query GetUserAuthState {
  userAuthState @client {
    isMiddlewareAuthenticated
  }
}
    `;

/**
 * __useGetUserAuthStateQuery__
 *
 * To run a query within a React component, call `useGetUserAuthStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAuthStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAuthStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAuthStateQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>(GetUserAuthStateDocument, options);
      }
export function useGetUserAuthStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>(GetUserAuthStateDocument, options);
        }
export type GetUserAuthStateQueryHookResult = ReturnType<typeof useGetUserAuthStateQuery>;
export type GetUserAuthStateLazyQueryHookResult = ReturnType<typeof useGetUserAuthStateLazyQuery>;
export type GetUserAuthStateQueryResult = Apollo.QueryResult<GetUserAuthStateQuery, GetUserAuthStateQueryVariables>;
export const GetUserLocaleDocument = gql`
    query GetUserLocale {
  userLocale @client {
    apiLocale
    cookieLocale
    languageKey
    routeLocale
  }
}
    `;

/**
 * __useGetUserLocaleQuery__
 *
 * To run a query within a React component, call `useGetUserLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLocaleQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLocaleQuery, GetUserLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLocaleQuery, GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
      }
export function useGetUserLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLocaleQuery, GetUserLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLocaleQuery, GetUserLocaleQueryVariables>(GetUserLocaleDocument, options);
        }
export type GetUserLocaleQueryHookResult = ReturnType<typeof useGetUserLocaleQuery>;
export type GetUserLocaleLazyQueryHookResult = ReturnType<typeof useGetUserLocaleLazyQuery>;
export type GetUserLocaleQueryResult = Apollo.QueryResult<GetUserLocaleQuery, GetUserLocaleQueryVariables>;
export const GetUserLocationDocument = gql`
    query GetUserLocation {
  userLocation @client {
    id
    isRegion
    name {
      en_CA
      fr_CA
    }
    area {
      latitude
      longitude
      radius
      address
    }
  }
}
    `;

/**
 * __useGetUserLocationQuery__
 *
 * To run a query within a React component, call `useGetUserLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetUserLocationQuery, GetUserLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserLocationQuery, GetUserLocationQueryVariables>(GetUserLocationDocument, options);
      }
export function useGetUserLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserLocationQuery, GetUserLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserLocationQuery, GetUserLocationQueryVariables>(GetUserLocationDocument, options);
        }
export type GetUserLocationQueryHookResult = ReturnType<typeof useGetUserLocationQuery>;
export type GetUserLocationLazyQueryHookResult = ReturnType<typeof useGetUserLocationLazyQuery>;
export type GetUserLocationQueryResult = Apollo.QueryResult<GetUserLocationQuery, GetUserLocationQueryVariables>;
export const GetContentModuleDocument = gql`
    query GetContentModule($locationId: Int!, $moduleId: ContentModuleID!) {
  contentModule(locationId: $locationId, moduleId: $moduleId) {
    ... on BrowseHeroModule {
      component
      title {
        text
        style {
          color
          isBold
        }
      }
      partner {
        title
        brand {
          logoUrl
          link
        }
      }
      tiles {
        title
        link {
          url
          isNewTab
        }
        tracking {
          action
          label
        }
        background {
          imageUrl
          altText
        }
        type
      }
    }
  }
}
    `;

/**
 * __useGetContentModuleQuery__
 *
 * To run a query within a React component, call `useGetContentModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentModuleQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetContentModuleQuery(baseOptions: Apollo.QueryHookOptions<GetContentModuleQuery, GetContentModuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentModuleQuery, GetContentModuleQueryVariables>(GetContentModuleDocument, options);
      }
export function useGetContentModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentModuleQuery, GetContentModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentModuleQuery, GetContentModuleQueryVariables>(GetContentModuleDocument, options);
        }
export type GetContentModuleQueryHookResult = ReturnType<typeof useGetContentModuleQuery>;
export type GetContentModuleLazyQueryHookResult = ReturnType<typeof useGetContentModuleLazyQuery>;
export type GetContentModuleQueryResult = Apollo.QueryResult<GetContentModuleQuery, GetContentModuleQueryVariables>;
export const FavouriteSearchActivateDocument = gql`
    mutation FavouriteSearchActivate($input: FavouriteSearchActivateInput!) {
  favouriteSearchActivate(input: $input)
}
    `;
export type FavouriteSearchActivateMutationFn = Apollo.MutationFunction<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>;

/**
 * __useFavouriteSearchActivateMutation__
 *
 * To run a mutation, you first call `useFavouriteSearchActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteSearchActivateMutation, { data, loading, error }] = useFavouriteSearchActivateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavouriteSearchActivateMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>(FavouriteSearchActivateDocument, options);
      }
export type FavouriteSearchActivateMutationHookResult = ReturnType<typeof useFavouriteSearchActivateMutation>;
export type FavouriteSearchActivateMutationResult = Apollo.MutationResult<FavouriteSearchActivateMutation>;
export type FavouriteSearchActivateMutationOptions = Apollo.BaseMutationOptions<FavouriteSearchActivateMutation, FavouriteSearchActivateMutationVariables>;
export const FavouriteSearchActivateGuestDocument = gql`
    mutation FavouriteSearchActivateGuest($searchString: String!, $email: String!) {
  activateFavouriteSearchGuest(searchString: $searchString, email: $email)
}
    `;
export type FavouriteSearchActivateGuestMutationFn = Apollo.MutationFunction<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>;

/**
 * __useFavouriteSearchActivateGuestMutation__
 *
 * To run a mutation, you first call `useFavouriteSearchActivateGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchActivateGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteSearchActivateGuestMutation, { data, loading, error }] = useFavouriteSearchActivateGuestMutation({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useFavouriteSearchActivateGuestMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>(FavouriteSearchActivateGuestDocument, options);
      }
export type FavouriteSearchActivateGuestMutationHookResult = ReturnType<typeof useFavouriteSearchActivateGuestMutation>;
export type FavouriteSearchActivateGuestMutationResult = Apollo.MutationResult<FavouriteSearchActivateGuestMutation>;
export type FavouriteSearchActivateGuestMutationOptions = Apollo.BaseMutationOptions<FavouriteSearchActivateGuestMutation, FavouriteSearchActivateGuestMutationVariables>;
export const FavouriteSearchDeactivateDocument = gql`
    mutation FavouriteSearchDeactivate($favouriteSearchDeactivateId: ID!) {
  favouriteSearchDeactivate(id: $favouriteSearchDeactivateId)
}
    `;
export type FavouriteSearchDeactivateMutationFn = Apollo.MutationFunction<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>;

/**
 * __useFavouriteSearchDeactivateMutation__
 *
 * To run a mutation, you first call `useFavouriteSearchDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favouriteSearchDeactivateMutation, { data, loading, error }] = useFavouriteSearchDeactivateMutation({
 *   variables: {
 *      favouriteSearchDeactivateId: // value for 'favouriteSearchDeactivateId'
 *   },
 * });
 */
export function useFavouriteSearchDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>(FavouriteSearchDeactivateDocument, options);
      }
export type FavouriteSearchDeactivateMutationHookResult = ReturnType<typeof useFavouriteSearchDeactivateMutation>;
export type FavouriteSearchDeactivateMutationResult = Apollo.MutationResult<FavouriteSearchDeactivateMutation>;
export type FavouriteSearchDeactivateMutationOptions = Apollo.BaseMutationOptions<FavouriteSearchDeactivateMutation, FavouriteSearchDeactivateMutationVariables>;
export const FavouriteSearchIdLookupDocument = gql`
    query FavouriteSearchIdLookup($input: FavouriteSearchIdLookupInput!) {
  favouriteSearchIdLookup(input: $input) {
    id
    active
  }
}
    `;

/**
 * __useFavouriteSearchIdLookupQuery__
 *
 * To run a query within a React component, call `useFavouriteSearchIdLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavouriteSearchIdLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavouriteSearchIdLookupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavouriteSearchIdLookupQuery(baseOptions: Apollo.QueryHookOptions<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>(FavouriteSearchIdLookupDocument, options);
      }
export function useFavouriteSearchIdLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>(FavouriteSearchIdLookupDocument, options);
        }
export type FavouriteSearchIdLookupQueryHookResult = ReturnType<typeof useFavouriteSearchIdLookupQuery>;
export type FavouriteSearchIdLookupLazyQueryHookResult = ReturnType<typeof useFavouriteSearchIdLookupLazyQuery>;
export type FavouriteSearchIdLookupQueryResult = Apollo.QueryResult<FavouriteSearchIdLookupQuery, FavouriteSearchIdLookupQueryVariables>;
export const GetSearchCategoriesDocument = gql`
    query getSearchCategories($locale: String!) {
  searchCategories {
    id
    localizedName(locale: $locale)
    parentId
  }
}
    `;

/**
 * __useGetSearchCategoriesQuery__
 *
 * To run a query within a React component, call `useGetSearchCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCategoriesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetSearchCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>(GetSearchCategoriesDocument, options);
      }
export function useGetSearchCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>(GetSearchCategoriesDocument, options);
        }
export type GetSearchCategoriesQueryHookResult = ReturnType<typeof useGetSearchCategoriesQuery>;
export type GetSearchCategoriesLazyQueryHookResult = ReturnType<typeof useGetSearchCategoriesLazyQuery>;
export type GetSearchCategoriesQueryResult = Apollo.QueryResult<GetSearchCategoriesQuery, GetSearchCategoriesQueryVariables>;
export const GetGoogleMapsKeyDocument = gql`
    mutation GetGoogleMapsKey {
  getGoogleMapsKey
}
    `;
export type GetGoogleMapsKeyMutationFn = Apollo.MutationFunction<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>;

/**
 * __useGetGoogleMapsKeyMutation__
 *
 * To run a mutation, you first call `useGetGoogleMapsKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetGoogleMapsKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getGoogleMapsKeyMutation, { data, loading, error }] = useGetGoogleMapsKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetGoogleMapsKeyMutation(baseOptions?: Apollo.MutationHookOptions<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>(GetGoogleMapsKeyDocument, options);
      }
export type GetGoogleMapsKeyMutationHookResult = ReturnType<typeof useGetGoogleMapsKeyMutation>;
export type GetGoogleMapsKeyMutationResult = Apollo.MutationResult<GetGoogleMapsKeyMutation>;
export type GetGoogleMapsKeyMutationOptions = Apollo.BaseMutationOptions<GetGoogleMapsKeyMutation, GetGoogleMapsKeyMutationVariables>;
export const GetPlaceSuggestionsDocument = gql`
    query GetPlaceSuggestions($input: String!, $location: LocationQueryCoordsOptions) {
  placeSuggestions(input: $input, location: $location) {
    placeId
    address
  }
}
    `;

/**
 * __useGetPlaceSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetPlaceSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetPlaceSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>(GetPlaceSuggestionsDocument, options);
      }
export function useGetPlaceSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>(GetPlaceSuggestionsDocument, options);
        }
export type GetPlaceSuggestionsQueryHookResult = ReturnType<typeof useGetPlaceSuggestionsQuery>;
export type GetPlaceSuggestionsLazyQueryHookResult = ReturnType<typeof useGetPlaceSuggestionsLazyQuery>;
export type GetPlaceSuggestionsQueryResult = Apollo.QueryResult<GetPlaceSuggestionsQuery, GetPlaceSuggestionsQueryVariables>;
export const GetPlaceTokenDocument = gql`
    mutation getPlaceToken {
  getPlaceToken
}
    `;
export type GetPlaceTokenMutationFn = Apollo.MutationFunction<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>;

/**
 * __useGetPlaceTokenMutation__
 *
 * To run a mutation, you first call `useGetPlaceTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPlaceTokenMutation, { data, loading, error }] = useGetPlaceTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetPlaceTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>(GetPlaceTokenDocument, options);
      }
export type GetPlaceTokenMutationHookResult = ReturnType<typeof useGetPlaceTokenMutation>;
export type GetPlaceTokenMutationResult = Apollo.MutationResult<GetPlaceTokenMutation>;
export type GetPlaceTokenMutationOptions = Apollo.BaseMutationOptions<GetPlaceTokenMutation, GetPlaceTokenMutationVariables>;
export const GetCategoriesNearYouDocument = gql`
    query GetCategoriesNearYou($locationId: Int!) {
  menuPrefetch(locationId: $locationId) {
    id
    categoryName
    seoUrl
  }
}
    `;

/**
 * __useGetCategoriesNearYouQuery__
 *
 * To run a query within a React component, call `useGetCategoriesNearYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesNearYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesNearYouQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetCategoriesNearYouQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>(GetCategoriesNearYouDocument, options);
      }
export function useGetCategoriesNearYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>(GetCategoriesNearYouDocument, options);
        }
export type GetCategoriesNearYouQueryHookResult = ReturnType<typeof useGetCategoriesNearYouQuery>;
export type GetCategoriesNearYouLazyQueryHookResult = ReturnType<typeof useGetCategoriesNearYouLazyQuery>;
export type GetCategoriesNearYouQueryResult = Apollo.QueryResult<GetCategoriesNearYouQuery, GetCategoriesNearYouQueryVariables>;
export const GetFeedRecommendationsDocument = gql`
    query GetFeedRecommendations($input: FeedRecommendationsInput!) {
  feedRecommendations(input: $input) {
    seedId
    description
    seoUrl
    ads {
      id
      imageUrls
      price {
        amount
        type
      }
      seoUrl
      title
      type
    }
  }
}
    `;

/**
 * __useGetFeedRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetFeedRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>(GetFeedRecommendationsDocument, options);
      }
export function useGetFeedRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>(GetFeedRecommendationsDocument, options);
        }
export type GetFeedRecommendationsQueryHookResult = ReturnType<typeof useGetFeedRecommendationsQuery>;
export type GetFeedRecommendationsLazyQueryHookResult = ReturnType<typeof useGetFeedRecommendationsLazyQuery>;
export type GetFeedRecommendationsQueryResult = Apollo.QueryResult<GetFeedRecommendationsQuery, GetFeedRecommendationsQueryVariables>;
export const GetHomeFeedDocument = gql`
    query GetHomeFeed($input: HomeFeedInput!, $homePageMixGroup: String) {
  homeFeed(input: $input, homePageMixGroup: $homePageMixGroup) {
    pageInfo {
      currentPage
      numberOfAds
      hasNextPage
      links
    }
    results {
      ... on FeedItem {
        id
        imageUrls
        processorName
        seoUrl
        title
        type
        price {
          amount
          type
        }
      }
      ... on PopularCategoryItem {
        id
        seoUrl
        title
      }
      ... on BrandedCategoryItem {
        id
        imageUrl
        seoUrl
        title
      }
    }
  }
}
    `;

/**
 * __useGetHomeFeedQuery__
 *
 * To run a query within a React component, call `useGetHomeFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeFeedQuery({
 *   variables: {
 *      input: // value for 'input'
 *      homePageMixGroup: // value for 'homePageMixGroup'
 *   },
 * });
 */
export function useGetHomeFeedQuery(baseOptions: Apollo.QueryHookOptions<GetHomeFeedQuery, GetHomeFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeFeedQuery, GetHomeFeedQueryVariables>(GetHomeFeedDocument, options);
      }
export function useGetHomeFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeFeedQuery, GetHomeFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeFeedQuery, GetHomeFeedQueryVariables>(GetHomeFeedDocument, options);
        }
export type GetHomeFeedQueryHookResult = ReturnType<typeof useGetHomeFeedQuery>;
export type GetHomeFeedLazyQueryHookResult = ReturnType<typeof useGetHomeFeedLazyQuery>;
export type GetHomeFeedQueryResult = Apollo.QueryResult<GetHomeFeedQuery, GetHomeFeedQueryVariables>;
export const GetHomepageGalleryDocument = gql`
    query GetHomepageGallery($deviceType: String!, $locationId: Int!, $page: Int!, $locale: String, $numberOfAds: Int) {
  homepageGallery(
    deviceType: $deviceType
    locationId: $locationId
    page: $page
    locale: $locale
    numberOfAds: $numberOfAds
  ) {
    items {
      id
      imageAltText
      imageUrl
      price {
        amount
        type
      }
      title
      seoUrl
    }
  }
}
    `;

/**
 * __useGetHomepageGalleryQuery__
 *
 * To run a query within a React component, call `useGetHomepageGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomepageGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomepageGalleryQuery({
 *   variables: {
 *      deviceType: // value for 'deviceType'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      locale: // value for 'locale'
 *      numberOfAds: // value for 'numberOfAds'
 *   },
 * });
 */
export function useGetHomepageGalleryQuery(baseOptions: Apollo.QueryHookOptions<GetHomepageGalleryQuery, GetHomepageGalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomepageGalleryQuery, GetHomepageGalleryQueryVariables>(GetHomepageGalleryDocument, options);
      }
export function useGetHomepageGalleryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomepageGalleryQuery, GetHomepageGalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomepageGalleryQuery, GetHomepageGalleryQueryVariables>(GetHomepageGalleryDocument, options);
        }
export type GetHomepageGalleryQueryHookResult = ReturnType<typeof useGetHomepageGalleryQuery>;
export type GetHomepageGalleryLazyQueryHookResult = ReturnType<typeof useGetHomepageGalleryLazyQuery>;
export type GetHomepageGalleryQueryResult = Apollo.QueryResult<GetHomepageGalleryQuery, GetHomepageGalleryQueryVariables>;
export const GetPopularKeywordsNearYouDocument = gql`
    query GetPopularKeywordsNearYou($searchUrlPopularInput: SearchUrlPopularRelatedInput!) {
  searchUrlsPopular(input: $searchUrlPopularInput) {
    label
    url
  }
}
    `;

/**
 * __useGetPopularKeywordsNearYouQuery__
 *
 * To run a query within a React component, call `useGetPopularKeywordsNearYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularKeywordsNearYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularKeywordsNearYouQuery({
 *   variables: {
 *      searchUrlPopularInput: // value for 'searchUrlPopularInput'
 *   },
 * });
 */
export function useGetPopularKeywordsNearYouQuery(baseOptions: Apollo.QueryHookOptions<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>(GetPopularKeywordsNearYouDocument, options);
      }
export function useGetPopularKeywordsNearYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>(GetPopularKeywordsNearYouDocument, options);
        }
export type GetPopularKeywordsNearYouQueryHookResult = ReturnType<typeof useGetPopularKeywordsNearYouQuery>;
export type GetPopularKeywordsNearYouLazyQueryHookResult = ReturnType<typeof useGetPopularKeywordsNearYouLazyQuery>;
export type GetPopularKeywordsNearYouQueryResult = Apollo.QueryResult<GetPopularKeywordsNearYouQuery, GetPopularKeywordsNearYouQueryVariables>;
export const GetRecentlyViewedListingsDocument = gql`
    query GetRecentlyViewedListings($userId: Int!) {
  user(userId: $userId) {
    recentlyViewedListings {
      title
      seoUrl
      price {
        amount
        type
      }
      imageUrls
      id
      locationId
      categoryId
    }
  }
}
    `;

/**
 * __useGetRecentlyViewedListingsQuery__
 *
 * To run a query within a React component, call `useGetRecentlyViewedListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentlyViewedListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentlyViewedListingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetRecentlyViewedListingsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>(GetRecentlyViewedListingsDocument, options);
      }
export function useGetRecentlyViewedListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>(GetRecentlyViewedListingsDocument, options);
        }
export type GetRecentlyViewedListingsQueryHookResult = ReturnType<typeof useGetRecentlyViewedListingsQuery>;
export type GetRecentlyViewedListingsLazyQueryHookResult = ReturnType<typeof useGetRecentlyViewedListingsLazyQuery>;
export type GetRecentlyViewedListingsQueryResult = Apollo.QueryResult<GetRecentlyViewedListingsQuery, GetRecentlyViewedListingsQueryVariables>;
export const GetRecommendedForYouDocument = gql`
    query GetRecommendedForYou($listingIds: [ID!]) {
  listingsRecommendedForYou(listingIds: $listingIds) {
    id
    title
    imageUrls
    url
    price {
      ... on StandardAmountPrice {
        amount
      }
    }
  }
}
    `;

/**
 * __useGetRecommendedForYouQuery__
 *
 * To run a query within a React component, call `useGetRecommendedForYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedForYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedForYouQuery({
 *   variables: {
 *      listingIds: // value for 'listingIds'
 *   },
 * });
 */
export function useGetRecommendedForYouQuery(baseOptions?: Apollo.QueryHookOptions<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>(GetRecommendedForYouDocument, options);
      }
export function useGetRecommendedForYouLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>(GetRecommendedForYouDocument, options);
        }
export type GetRecommendedForYouQueryHookResult = ReturnType<typeof useGetRecommendedForYouQuery>;
export type GetRecommendedForYouLazyQueryHookResult = ReturnType<typeof useGetRecommendedForYouLazyQuery>;
export type GetRecommendedForYouQueryResult = Apollo.QueryResult<GetRecommendedForYouQuery, GetRecommendedForYouQueryVariables>;
export const GetListingDocument = gql`
    query GetListing($listingId: ID!) {
  listing(id: $listingId) {
    activationDate
    adSource
    attributes {
      all {
        canonicalName
        canonicalValues
        values
        name
      }
    }
    categoryId
    description
    flags {
      categorySpecificBadge
      highlight
      hpGallery
      topAd
    }
    id
    imageUrls
    location {
      address
      coordinates {
        latitude
        longitude
      }
      id
      name
    }
    posterInfo {
      posterId
      sellerType
      websiteUrl
    }
    price {
      type
      ... on AmountPrice {
        amount
        currency
        originalAmount
      }
      ... on AutosDealerAmountPrice {
        amount
        currency
        originalAmount
        msrp
        surcharges
      }
    }
    sortingDate
    title
    type
    url
    views
    youtubeVideoId
  }
}
    `;

/**
 * __useGetListingQuery__
 *
 * To run a query within a React component, call `useGetListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetListingQuery(baseOptions: Apollo.QueryHookOptions<GetListingQuery, GetListingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListingQuery, GetListingQueryVariables>(GetListingDocument, options);
      }
export function useGetListingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListingQuery, GetListingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListingQuery, GetListingQueryVariables>(GetListingDocument, options);
        }
export type GetListingQueryHookResult = ReturnType<typeof useGetListingQuery>;
export type GetListingLazyQueryHookResult = ReturnType<typeof useGetListingLazyQuery>;
export type GetListingQueryResult = Apollo.QueryResult<GetListingQuery, GetListingQueryVariables>;
export const ListingReportDocument = gql`
    mutation ListingReport($listingReportId: ID!, $reason: Reason!, $email: String, $comment: String) {
  listingReport(
    id: $listingReportId
    reason: $reason
    email: $email
    comment: $comment
  )
}
    `;
export type ListingReportMutationFn = Apollo.MutationFunction<ListingReportMutation, ListingReportMutationVariables>;

/**
 * __useListingReportMutation__
 *
 * To run a mutation, you first call `useListingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingReportMutation, { data, loading, error }] = useListingReportMutation({
 *   variables: {
 *      listingReportId: // value for 'listingReportId'
 *      reason: // value for 'reason'
 *      email: // value for 'email'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useListingReportMutation(baseOptions?: Apollo.MutationHookOptions<ListingReportMutation, ListingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingReportMutation, ListingReportMutationVariables>(ListingReportDocument, options);
      }
export type ListingReportMutationHookResult = ReturnType<typeof useListingReportMutation>;
export type ListingReportMutationResult = Apollo.MutationResult<ListingReportMutation>;
export type ListingReportMutationOptions = Apollo.BaseMutationOptions<ListingReportMutation, ListingReportMutationVariables>;
export const ListingVisitDocument = gql`
    mutation ListingVisit($listingVisitId: ID!) {
  listingVisit(id: $listingVisitId)
}
    `;
export type ListingVisitMutationFn = Apollo.MutationFunction<ListingVisitMutation, ListingVisitMutationVariables>;

/**
 * __useListingVisitMutation__
 *
 * To run a mutation, you first call `useListingVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingVisitMutation, { data, loading, error }] = useListingVisitMutation({
 *   variables: {
 *      listingVisitId: // value for 'listingVisitId'
 *   },
 * });
 */
export function useListingVisitMutation(baseOptions?: Apollo.MutationHookOptions<ListingVisitMutation, ListingVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ListingVisitMutation, ListingVisitMutationVariables>(ListingVisitDocument, options);
      }
export type ListingVisitMutationHookResult = ReturnType<typeof useListingVisitMutation>;
export type ListingVisitMutationResult = Apollo.MutationResult<ListingVisitMutation>;
export type ListingVisitMutationOptions = Apollo.BaseMutationOptions<ListingVisitMutation, ListingVisitMutationVariables>;
export const VehicleReportDocument = gql`
    query VehicleReport($adId: Int!, $source: AdSource) {
  ad(id: $adId, source: $source) {
    ... on MoveAd {
      vehicleReport {
        badgeKeys
        reportUrl
      }
    }
  }
}
    `;

/**
 * __useVehicleReportQuery__
 *
 * To run a query within a React component, call `useVehicleReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleReportQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useVehicleReportQuery(baseOptions: Apollo.QueryHookOptions<VehicleReportQuery, VehicleReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleReportQuery, VehicleReportQueryVariables>(VehicleReportDocument, options);
      }
export function useVehicleReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleReportQuery, VehicleReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleReportQuery, VehicleReportQueryVariables>(VehicleReportDocument, options);
        }
export type VehicleReportQueryHookResult = ReturnType<typeof useVehicleReportQuery>;
export type VehicleReportLazyQueryHookResult = ReturnType<typeof useVehicleReportLazyQuery>;
export type VehicleReportQueryResult = Apollo.QueryResult<VehicleReportQuery, VehicleReportQueryVariables>;
export const GetGeocodeCanadianAddressDocument = gql`
    query GetGeocodeCanadianAddress($address: String!) {
  geocodeCanadianAddress(address: $address) {
    location {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetGeocodeCanadianAddressQuery__
 *
 * To run a query within a React component, call `useGetGeocodeCanadianAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeocodeCanadianAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeocodeCanadianAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetGeocodeCanadianAddressQuery(baseOptions: Apollo.QueryHookOptions<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>(GetGeocodeCanadianAddressDocument, options);
      }
export function useGetGeocodeCanadianAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>(GetGeocodeCanadianAddressDocument, options);
        }
export type GetGeocodeCanadianAddressQueryHookResult = ReturnType<typeof useGetGeocodeCanadianAddressQuery>;
export type GetGeocodeCanadianAddressLazyQueryHookResult = ReturnType<typeof useGetGeocodeCanadianAddressLazyQuery>;
export type GetGeocodeCanadianAddressQueryResult = Apollo.QueryResult<GetGeocodeCanadianAddressQuery, GetGeocodeCanadianAddressQueryVariables>;
export const GetGeocodeReverseFromIpDocument = gql`
    query GetGeocodeReverseFromIp {
  geocodeReverseFromIp {
    city
    province
    locationId
  }
}
    `;

/**
 * __useGetGeocodeReverseFromIpQuery__
 *
 * To run a query within a React component, call `useGetGeocodeReverseFromIpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeocodeReverseFromIpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeocodeReverseFromIpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeocodeReverseFromIpQuery(baseOptions?: Apollo.QueryHookOptions<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>(GetGeocodeReverseFromIpDocument, options);
      }
export function useGetGeocodeReverseFromIpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>(GetGeocodeReverseFromIpDocument, options);
        }
export type GetGeocodeReverseFromIpQueryHookResult = ReturnType<typeof useGetGeocodeReverseFromIpQuery>;
export type GetGeocodeReverseFromIpLazyQueryHookResult = ReturnType<typeof useGetGeocodeReverseFromIpLazyQuery>;
export type GetGeocodeReverseFromIpQueryResult = Apollo.QueryResult<GetGeocodeReverseFromIpQuery, GetGeocodeReverseFromIpQueryVariables>;
export const GetLocationFromCoordinatesDocument = gql`
    query GetLocationFromCoordinates($coordinates: LocationQueryCoordsOptions!) {
  locationFromCoordinates(coordinates: $coordinates) {
    location {
      id
      locationPaths {
        id
      }
      name {
        en_CA
        fr_CA
      }
    }
    place {
      address
      location {
        latitude
        longitude
      }
      postalCode {
        long
      }
    }
  }
}
    `;

/**
 * __useGetLocationFromCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetLocationFromCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationFromCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationFromCoordinatesQuery({
 *   variables: {
 *      coordinates: // value for 'coordinates'
 *   },
 * });
 */
export function useGetLocationFromCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>(GetLocationFromCoordinatesDocument, options);
      }
export function useGetLocationFromCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>(GetLocationFromCoordinatesDocument, options);
        }
export type GetLocationFromCoordinatesQueryHookResult = ReturnType<typeof useGetLocationFromCoordinatesQuery>;
export type GetLocationFromCoordinatesLazyQueryHookResult = ReturnType<typeof useGetLocationFromCoordinatesLazyQuery>;
export type GetLocationFromCoordinatesQueryResult = Apollo.QueryResult<GetLocationFromCoordinatesQuery, GetLocationFromCoordinatesQueryVariables>;
export const GetLocationFromIdDocument = gql`
    query getLocationFromId($locationId: Int!) {
  location(id: $locationId) {
    id
    localizedName
    name {
      en_CA
      fr_CA
    }
    coordinates {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetLocationFromIdQuery__
 *
 * To run a query within a React component, call `useGetLocationFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationFromIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>(GetLocationFromIdDocument, options);
      }
export function useGetLocationFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>(GetLocationFromIdDocument, options);
        }
export type GetLocationFromIdQueryHookResult = ReturnType<typeof useGetLocationFromIdQuery>;
export type GetLocationFromIdLazyQueryHookResult = ReturnType<typeof useGetLocationFromIdLazyQuery>;
export type GetLocationFromIdQueryResult = Apollo.QueryResult<GetLocationFromIdQuery, GetLocationFromIdQueryVariables>;
export const GetLocationFromPlaceDocument = gql`
    query GetLocationFromPlace($placeId: String!, $sessionToken: String) {
  locationFromPlace(placeId: $placeId, sessionToken: $sessionToken) {
    place {
      id
      address
      location {
        latitude
        longitude
      }
      postalCode {
        long
        short
      }
      isCountry
      isProvince
    }
    location {
      id
      coordinates {
        latitude
        longitude
      }
      name {
        en_CA
        fr_CA
      }
    }
  }
}
    `;

/**
 * __useGetLocationFromPlaceQuery__
 *
 * To run a query within a React component, call `useGetLocationFromPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationFromPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationFromPlaceQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetLocationFromPlaceQuery(baseOptions: Apollo.QueryHookOptions<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>(GetLocationFromPlaceDocument, options);
      }
export function useGetLocationFromPlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>(GetLocationFromPlaceDocument, options);
        }
export type GetLocationFromPlaceQueryHookResult = ReturnType<typeof useGetLocationFromPlaceQuery>;
export type GetLocationFromPlaceLazyQueryHookResult = ReturnType<typeof useGetLocationFromPlaceLazyQuery>;
export type GetLocationFromPlaceQueryResult = Apollo.QueryResult<GetLocationFromPlaceQuery, GetLocationFromPlaceQueryVariables>;
export const GetLocationPathFromIdDocument = gql`
    query GetLocationPathFromId($locationId: Int!) {
  location(id: $locationId) {
    locationPaths {
      id
      name {
        en_CA
        fr_CA
      }
    }
  }
}
    `;

/**
 * __useGetLocationPathFromIdQuery__
 *
 * To run a query within a React component, call `useGetLocationPathFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationPathFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationPathFromIdQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationPathFromIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>(GetLocationPathFromIdDocument, options);
      }
export function useGetLocationPathFromIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>(GetLocationPathFromIdDocument, options);
        }
export type GetLocationPathFromIdQueryHookResult = ReturnType<typeof useGetLocationPathFromIdQuery>;
export type GetLocationPathFromIdLazyQueryHookResult = ReturnType<typeof useGetLocationPathFromIdLazyQuery>;
export type GetLocationPathFromIdQueryResult = Apollo.QueryResult<GetLocationPathFromIdQuery, GetLocationPathFromIdQueryVariables>;
export const GetSocialLinksDocument = gql`
    query GetSocialLinks {
  myAccount {
    ...SocialLinksFields
  }
}
    ${SocialLinksFieldsFragmentDoc}`;

/**
 * __useGetSocialLinksQuery__
 *
 * To run a query within a React component, call `useGetSocialLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocialLinksQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialLinksQuery, GetSocialLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialLinksQuery, GetSocialLinksQueryVariables>(GetSocialLinksDocument, options);
      }
export function useGetSocialLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialLinksQuery, GetSocialLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialLinksQuery, GetSocialLinksQueryVariables>(GetSocialLinksDocument, options);
        }
export type GetSocialLinksQueryHookResult = ReturnType<typeof useGetSocialLinksQuery>;
export type GetSocialLinksLazyQueryHookResult = ReturnType<typeof useGetSocialLinksLazyQuery>;
export type GetSocialLinksQueryResult = Apollo.QueryResult<GetSocialLinksQuery, GetSocialLinksQueryVariables>;
export const UpdateSocialLinksDocument = gql`
    mutation UpdateSocialLinks($input: UpdateSocialLinksInput!) {
  updateSocialLinks(input: $input) {
    statusCode
  }
}
    `;
export type UpdateSocialLinksMutationFn = Apollo.MutationFunction<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>;

/**
 * __useUpdateSocialLinksMutation__
 *
 * To run a mutation, you first call `useUpdateSocialLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocialLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocialLinksMutation, { data, loading, error }] = useUpdateSocialLinksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocialLinksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>(UpdateSocialLinksDocument, options);
      }
export type UpdateSocialLinksMutationHookResult = ReturnType<typeof useUpdateSocialLinksMutation>;
export type UpdateSocialLinksMutationResult = Apollo.MutationResult<UpdateSocialLinksMutation>;
export type UpdateSocialLinksMutationOptions = Apollo.BaseMutationOptions<UpdateSocialLinksMutation, UpdateSocialLinksMutationVariables>;
export const AddFavouriteListingDocument = gql`
    mutation AddFavouriteListing($listingId: ID!) {
  addFavouriteListing(listingId: $listingId)
}
    `;
export type AddFavouriteListingMutationFn = Apollo.MutationFunction<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>;

/**
 * __useAddFavouriteListingMutation__
 *
 * To run a mutation, you first call `useAddFavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavouriteListingMutation, { data, loading, error }] = useAddFavouriteListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useAddFavouriteListingMutation(baseOptions?: Apollo.MutationHookOptions<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>(AddFavouriteListingDocument, options);
      }
export type AddFavouriteListingMutationHookResult = ReturnType<typeof useAddFavouriteListingMutation>;
export type AddFavouriteListingMutationResult = Apollo.MutationResult<AddFavouriteListingMutation>;
export type AddFavouriteListingMutationOptions = Apollo.BaseMutationOptions<AddFavouriteListingMutation, AddFavouriteListingMutationVariables>;
export const GetAuthModalStateDocument = gql`
    query GetAuthModalState {
  authModalState @client {
    isModalOpen
    modalVariant
    callbackUrl
  }
}
    `;

/**
 * __useGetAuthModalStateQuery__
 *
 * To run a query within a React component, call `useGetAuthModalStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthModalStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthModalStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthModalStateQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>(GetAuthModalStateDocument, options);
      }
export function useGetAuthModalStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>(GetAuthModalStateDocument, options);
        }
export type GetAuthModalStateQueryHookResult = ReturnType<typeof useGetAuthModalStateQuery>;
export type GetAuthModalStateLazyQueryHookResult = ReturnType<typeof useGetAuthModalStateLazyQuery>;
export type GetAuthModalStateQueryResult = Apollo.QueryResult<GetAuthModalStateQuery, GetAuthModalStateQueryVariables>;
export const GetSeoUrlDocument = gql`
    query GetSeoUrl($input: SearchUrlInput!) {
  searchUrl(input: $input)
}
    `;

/**
 * __useGetSeoUrlQuery__
 *
 * To run a query within a React component, call `useGetSeoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeoUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSeoUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSeoUrlQuery, GetSeoUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeoUrlQuery, GetSeoUrlQueryVariables>(GetSeoUrlDocument, options);
      }
export function useGetSeoUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeoUrlQuery, GetSeoUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeoUrlQuery, GetSeoUrlQueryVariables>(GetSeoUrlDocument, options);
        }
export type GetSeoUrlQueryHookResult = ReturnType<typeof useGetSeoUrlQuery>;
export type GetSeoUrlLazyQueryHookResult = ReturnType<typeof useGetSeoUrlLazyQuery>;
export type GetSeoUrlQueryResult = Apollo.QueryResult<GetSeoUrlQuery, GetSeoUrlQueryVariables>;
export const GetSearchResultsPageByUrlDocument = gql`
    query GetSearchResultsPageByUrl($searchResultsByUrlInput: SearchResultsByUrlInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    ...CoreSRP
    searchQuery {
      ...CoreSearchQuery
      filters {
        filterName
        ... on AppliedAdditionalFlagsFilter {
          flags
        }
        ... on AppliedAttributeFilter {
          values
        }
        ... on AppliedRangeFilter {
          minValue
          maxValue
        }
        ... on AppliedDateRangeFilter {
          start
          end
        }
        ... on AppliedDateFilter {
          value
        }
        ... on AppliedToggleFilter {
          toggleValue
        }
      }
    }
  }
}
    ${CoreSrpFragmentDoc}
${CoreSearchQueryFragmentDoc}`;

/**
 * __useGetSearchResultsPageByUrlQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsPageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsPageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsPageByUrlQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *   },
 * });
 */
export function useGetSearchResultsPageByUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>(GetSearchResultsPageByUrlDocument, options);
      }
export function useGetSearchResultsPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>(GetSearchResultsPageByUrlDocument, options);
        }
export type GetSearchResultsPageByUrlQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlQuery>;
export type GetSearchResultsPageByUrlLazyQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlLazyQuery>;
export type GetSearchResultsPageByUrlQueryResult = Apollo.QueryResult<GetSearchResultsPageByUrlQuery, GetSearchResultsPageByUrlQueryVariables>;
export const GetSearchResultsPageByUrlWithSeoDocument = gql`
    query GetSearchResultsPageByUrlWithSeo($searchResultsByUrlInput: SearchResultsByUrlInput!, $searchUrlPopularInput: SearchUrlPopularRelatedInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    ...CoreSRP
    searchQuery {
      ...CoreSearchQuery
      filters {
        filterName
        ... on AppliedAdditionalFlagsFilter {
          flags
        }
        ... on AppliedAttributeFilter {
          values
        }
        ... on AppliedRangeFilter {
          minValue
          maxValue
        }
        ... on AppliedDateRangeFilter {
          start
          end
        }
        ... on AppliedDateFilter {
          value
        }
        ... on AppliedToggleFilter {
          toggleValue
        }
      }
    }
  }
  searchUrlsPopular(input: $searchUrlPopularInput) {
    label
    url
  }
}
    ${CoreSrpFragmentDoc}
${CoreSearchQueryFragmentDoc}`;

/**
 * __useGetSearchResultsPageByUrlWithSeoQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsPageByUrlWithSeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsPageByUrlWithSeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsPageByUrlWithSeoQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *      searchUrlPopularInput: // value for 'searchUrlPopularInput'
 *   },
 * });
 */
export function useGetSearchResultsPageByUrlWithSeoQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>(GetSearchResultsPageByUrlWithSeoDocument, options);
      }
export function useGetSearchResultsPageByUrlWithSeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>(GetSearchResultsPageByUrlWithSeoDocument, options);
        }
export type GetSearchResultsPageByUrlWithSeoQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlWithSeoQuery>;
export type GetSearchResultsPageByUrlWithSeoLazyQueryHookResult = ReturnType<typeof useGetSearchResultsPageByUrlWithSeoLazyQuery>;
export type GetSearchResultsPageByUrlWithSeoQueryResult = Apollo.QueryResult<GetSearchResultsPageByUrlWithSeoQuery, GetSearchResultsPageByUrlWithSeoQueryVariables>;
export const GetAppliedFiltersDocument = gql`
    query GetAppliedFilters($searchResultsByUrlInput: SearchResultsByUrlInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    searchQuery {
      filters {
        filterName
        ... on AppliedAttributeFilter {
          values
        }
        ... on AppliedRangeFilter {
          maxValue
          minValue
        }
        ... on AppliedDateRangeFilter {
          end
          start
        }
        ... on AppliedDateFilter {
          value
        }
        ... on AppliedToggleFilter {
          toggleValue
        }
      }
    }
    pagination {
      totalCount
    }
  }
}
    `;

/**
 * __useGetAppliedFiltersQuery__
 *
 * To run a query within a React component, call `useGetAppliedFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppliedFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppliedFiltersQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *   },
 * });
 */
export function useGetAppliedFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetAppliedFiltersQuery, GetAppliedFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppliedFiltersQuery, GetAppliedFiltersQueryVariables>(GetAppliedFiltersDocument, options);
      }
export function useGetAppliedFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppliedFiltersQuery, GetAppliedFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppliedFiltersQuery, GetAppliedFiltersQueryVariables>(GetAppliedFiltersDocument, options);
        }
export type GetAppliedFiltersQueryHookResult = ReturnType<typeof useGetAppliedFiltersQuery>;
export type GetAppliedFiltersLazyQueryHookResult = ReturnType<typeof useGetAppliedFiltersLazyQuery>;
export type GetAppliedFiltersQueryResult = Apollo.QueryResult<GetAppliedFiltersQuery, GetAppliedFiltersQueryVariables>;
export const GetBreadcrumbsBySearchPageUrlDocument = gql`
    query GetBreadcrumbsBySearchPageUrl($searchResultsByUrlInput: SearchResultsByUrlInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    searchQuery {
      ...BreadcrumbsSearchQuery
    }
  }
}
    ${BreadcrumbsSearchQueryFragmentDoc}`;

/**
 * __useGetBreadcrumbsBySearchPageUrlQuery__
 *
 * To run a query within a React component, call `useGetBreadcrumbsBySearchPageUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBreadcrumbsBySearchPageUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBreadcrumbsBySearchPageUrlQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *   },
 * });
 */
export function useGetBreadcrumbsBySearchPageUrlQuery(baseOptions: Apollo.QueryHookOptions<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>(GetBreadcrumbsBySearchPageUrlDocument, options);
      }
export function useGetBreadcrumbsBySearchPageUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>(GetBreadcrumbsBySearchPageUrlDocument, options);
        }
export type GetBreadcrumbsBySearchPageUrlQueryHookResult = ReturnType<typeof useGetBreadcrumbsBySearchPageUrlQuery>;
export type GetBreadcrumbsBySearchPageUrlLazyQueryHookResult = ReturnType<typeof useGetBreadcrumbsBySearchPageUrlLazyQuery>;
export type GetBreadcrumbsBySearchPageUrlQueryResult = Apollo.QueryResult<GetBreadcrumbsBySearchPageUrlQuery, GetBreadcrumbsBySearchPageUrlQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($categoryId: Int!) {
  category(id: $categoryId) {
    id
    localizedName
    parentId
    categoryPaths {
      id
      localizedName
      parentId
    }
    attributes {
      id
      canonicalName
      localizedFields {
        canonicalValue
        seoSlug
        value
      }
    }
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetUserFavouritesListDocument = gql`
    query GetUserFavouritesList {
  favouriteListingsIds
}
    `;

/**
 * __useGetUserFavouritesListQuery__
 *
 * To run a query within a React component, call `useGetUserFavouritesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavouritesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavouritesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserFavouritesListQuery(baseOptions?: Apollo.QueryHookOptions<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>(GetUserFavouritesListDocument, options);
      }
export function useGetUserFavouritesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>(GetUserFavouritesListDocument, options);
        }
export type GetUserFavouritesListQueryHookResult = ReturnType<typeof useGetUserFavouritesListQuery>;
export type GetUserFavouritesListLazyQueryHookResult = ReturnType<typeof useGetUserFavouritesListLazyQuery>;
export type GetUserFavouritesListQueryResult = Apollo.QueryResult<GetUserFavouritesListQuery, GetUserFavouritesListQueryVariables>;
export const GetFilterDrawerStateDocument = gql`
    query GetFilterDrawerState {
  srp @client {
    isFilterDrawerOpen
    selectedAccordionItems
  }
}
    `;

/**
 * __useGetFilterDrawerStateQuery__
 *
 * To run a query within a React component, call `useGetFilterDrawerStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterDrawerStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterDrawerStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterDrawerStateQuery(baseOptions?: Apollo.QueryHookOptions<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>(GetFilterDrawerStateDocument, options);
      }
export function useGetFilterDrawerStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>(GetFilterDrawerStateDocument, options);
        }
export type GetFilterDrawerStateQueryHookResult = ReturnType<typeof useGetFilterDrawerStateQuery>;
export type GetFilterDrawerStateLazyQueryHookResult = ReturnType<typeof useGetFilterDrawerStateLazyQuery>;
export type GetFilterDrawerStateQueryResult = Apollo.QueryResult<GetFilterDrawerStateQuery, GetFilterDrawerStateQueryVariables>;
export const GetOrganicListingsDocument = gql`
    query GetOrganicListings($input: SearchResultsInput!) {
  searchResultsPageUpdate(input: $input) {
    results {
      mainListings {
        id
        title
        description
        imageUrls
        categoryId
        url
        activationDate
        sortingDate
        adSource
        location {
          id
          name
          address
          distance
          nearestIntersection
        }
        price {
          type
          ... on StandardAmountPrice {
            amount
            originalAmount
          }
          ... on AutosDealerAmountPrice {
            amount
            originalAmount
            msrp
            surcharges
          }
        }
        attributes {
          all {
            canonicalName
            canonicalValues
          }
        }
        flags {
          categorySpecificBadge
          priceDrop
          showcase
          topAd
          highlight
          shippedBySeller
          isPromotionProvTopAd
          isPromotionTopAd
          ... on RealEstateListingFlags {
            virtualTour
          }
        }
        posterInfo {
          posterId
        }
        ... on AutosListing {
          moveUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganicListingsQuery__
 *
 * To run a query within a React component, call `useGetOrganicListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganicListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganicListingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganicListingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>(GetOrganicListingsDocument, options);
      }
export function useGetOrganicListingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>(GetOrganicListingsDocument, options);
        }
export type GetOrganicListingsQueryHookResult = ReturnType<typeof useGetOrganicListingsQuery>;
export type GetOrganicListingsLazyQueryHookResult = ReturnType<typeof useGetOrganicListingsLazyQuery>;
export type GetOrganicListingsQueryResult = Apollo.QueryResult<GetOrganicListingsQuery, GetOrganicListingsQueryVariables>;
export const GetPopularRelatedKeywordsDocument = gql`
    query GetPopularRelatedKeywords($searchUrlPopularInput: SearchUrlPopularRelatedInput!) {
  searchUrlsPopular(input: $searchUrlPopularInput) {
    label
    url
  }
}
    `;

/**
 * __useGetPopularRelatedKeywordsQuery__
 *
 * To run a query within a React component, call `useGetPopularRelatedKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularRelatedKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularRelatedKeywordsQuery({
 *   variables: {
 *      searchUrlPopularInput: // value for 'searchUrlPopularInput'
 *   },
 * });
 */
export function useGetPopularRelatedKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>(GetPopularRelatedKeywordsDocument, options);
      }
export function useGetPopularRelatedKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>(GetPopularRelatedKeywordsDocument, options);
        }
export type GetPopularRelatedKeywordsQueryHookResult = ReturnType<typeof useGetPopularRelatedKeywordsQuery>;
export type GetPopularRelatedKeywordsLazyQueryHookResult = ReturnType<typeof useGetPopularRelatedKeywordsLazyQuery>;
export type GetPopularRelatedKeywordsQueryResult = Apollo.QueryResult<GetPopularRelatedKeywordsQuery, GetPopularRelatedKeywordsQueryVariables>;
export const GetSearchFiltersDocument = gql`
    query GetSearchFilters($searchResultsByUrlInput: SearchResultsByUrlInput!) {
  searchResultsPageByUrl(input: $searchResultsByUrlInput) {
    controls {
      filtering {
        name
        label
        shouldShowTopLevelAccordion
        quickFilterSortOrder
        filters {
          __typename
          ... on AttributeFilter {
            ...AttributeFilterFields
          }
          ... on RangeFilter {
            ...RangeFilterFields
          }
          ... on DateFilter {
            ...DateFilterFields
          }
          ... on ToggleFilter {
            ...ToggleFilterFields
          }
        }
      }
    }
    searchQuery {
      category {
        id
      }
      filters {
        filterName
        ... on AppliedAdditionalFlagsFilter {
          flags
        }
        ... on AppliedAttributeFilter {
          values
        }
        ... on AppliedRangeFilter {
          minValue
          maxValue
        }
        ... on AppliedDateRangeFilter {
          start
          end
        }
        ... on AppliedDateFilter {
          value
        }
        ... on AppliedToggleFilter {
          toggleValue
        }
      }
    }
  }
}
    ${AttributeFilterFieldsFragmentDoc}
${RangeFilterFieldsFragmentDoc}
${DateFilterFieldsFragmentDoc}
${ToggleFilterFieldsFragmentDoc}`;

/**
 * __useGetSearchFiltersQuery__
 *
 * To run a query within a React component, call `useGetSearchFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchFiltersQuery({
 *   variables: {
 *      searchResultsByUrlInput: // value for 'searchResultsByUrlInput'
 *   },
 * });
 */
export function useGetSearchFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>(GetSearchFiltersDocument, options);
      }
export function useGetSearchFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>(GetSearchFiltersDocument, options);
        }
export type GetSearchFiltersQueryHookResult = ReturnType<typeof useGetSearchFiltersQuery>;
export type GetSearchFiltersLazyQueryHookResult = ReturnType<typeof useGetSearchFiltersLazyQuery>;
export type GetSearchFiltersQueryResult = Apollo.QueryResult<GetSearchFiltersQuery, GetSearchFiltersQueryVariables>;
export const GetSearchUrlDocument = gql`
    query GetSearchUrl($input: SearchUrlInput!) {
  searchUrl(input: $input)
}
    `;

/**
 * __useGetSearchUrlQuery__
 *
 * To run a query within a React component, call `useGetSearchUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSearchUrlQuery(baseOptions: Apollo.QueryHookOptions<GetSearchUrlQuery, GetSearchUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchUrlQuery, GetSearchUrlQueryVariables>(GetSearchUrlDocument, options);
      }
export function useGetSearchUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchUrlQuery, GetSearchUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchUrlQuery, GetSearchUrlQueryVariables>(GetSearchUrlDocument, options);
        }
export type GetSearchUrlQueryHookResult = ReturnType<typeof useGetSearchUrlQuery>;
export type GetSearchUrlLazyQueryHookResult = ReturnType<typeof useGetSearchUrlLazyQuery>;
export type GetSearchUrlQueryResult = Apollo.QueryResult<GetSearchUrlQuery, GetSearchUrlQueryVariables>;
export const GetSearchLoadingStateDocument = gql`
    query GetSearchLoadingState {
  srp @client {
    loadingFilters
    loadingResults
  }
}
    `;

/**
 * __useGetSearchLoadingStateQuery__
 *
 * To run a query within a React component, call `useGetSearchLoadingStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchLoadingStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchLoadingStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchLoadingStateQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>(GetSearchLoadingStateDocument, options);
      }
export function useGetSearchLoadingStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>(GetSearchLoadingStateDocument, options);
        }
export type GetSearchLoadingStateQueryHookResult = ReturnType<typeof useGetSearchLoadingStateQuery>;
export type GetSearchLoadingStateLazyQueryHookResult = ReturnType<typeof useGetSearchLoadingStateLazyQuery>;
export type GetSearchLoadingStateQueryResult = Apollo.QueryResult<GetSearchLoadingStateQuery, GetSearchLoadingStateQueryVariables>;
export const GetPendingSearchInputDocument = gql`
    query GetPendingSearchInput {
  srp @client {
    pendingSearchInput {
      keywords
      by
      direction
      offset
      additionalFlagFilters
      attributeFilters {
        filterName
        values
      }
      rangeFilters {
        filterName
        minValue
        maxValue
      }
      dateRangeFilters {
        filterName
        start
        end
      }
      dateFilters {
        filterName
        value
      }
      toggleFilters {
        filterName
        toggleValue
      }
    }
  }
}
    `;

/**
 * __useGetPendingSearchInputQuery__
 *
 * To run a query within a React component, call `useGetPendingSearchInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingSearchInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingSearchInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingSearchInputQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>(GetPendingSearchInputDocument, options);
      }
export function useGetPendingSearchInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>(GetPendingSearchInputDocument, options);
        }
export type GetPendingSearchInputQueryHookResult = ReturnType<typeof useGetPendingSearchInputQuery>;
export type GetPendingSearchInputLazyQueryHookResult = ReturnType<typeof useGetPendingSearchInputLazyQuery>;
export type GetPendingSearchInputQueryResult = Apollo.QueryResult<GetPendingSearchInputQuery, GetPendingSearchInputQueryVariables>;
export const GetVipUrlDocument = gql`
    query GetVipUrl($adId: ID!) {
  listingUrl(id: $adId)
}
    `;

/**
 * __useGetVipUrlQuery__
 *
 * To run a query within a React component, call `useGetVipUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVipUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVipUrlQuery({
 *   variables: {
 *      adId: // value for 'adId'
 *   },
 * });
 */
export function useGetVipUrlQuery(baseOptions: Apollo.QueryHookOptions<GetVipUrlQuery, GetVipUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVipUrlQuery, GetVipUrlQueryVariables>(GetVipUrlDocument, options);
      }
export function useGetVipUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVipUrlQuery, GetVipUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVipUrlQuery, GetVipUrlQueryVariables>(GetVipUrlDocument, options);
        }
export type GetVipUrlQueryHookResult = ReturnType<typeof useGetVipUrlQuery>;
export type GetVipUrlLazyQueryHookResult = ReturnType<typeof useGetVipUrlLazyQuery>;
export type GetVipUrlQueryResult = Apollo.QueryResult<GetVipUrlQuery, GetVipUrlQueryVariables>;
export const OneTimeSavedSearchDocument = gql`
    mutation oneTimeSavedSearch($input: OneTimeSavedSearchInput!) {
  oneTimeSavedSearch(input: $input)
}
    `;
export type OneTimeSavedSearchMutationFn = Apollo.MutationFunction<OneTimeSavedSearchMutation, OneTimeSavedSearchMutationVariables>;

/**
 * __useOneTimeSavedSearchMutation__
 *
 * To run a mutation, you first call `useOneTimeSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOneTimeSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oneTimeSavedSearchMutation, { data, loading, error }] = useOneTimeSavedSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOneTimeSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<OneTimeSavedSearchMutation, OneTimeSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OneTimeSavedSearchMutation, OneTimeSavedSearchMutationVariables>(OneTimeSavedSearchDocument, options);
      }
export type OneTimeSavedSearchMutationHookResult = ReturnType<typeof useOneTimeSavedSearchMutation>;
export type OneTimeSavedSearchMutationResult = Apollo.MutationResult<OneTimeSavedSearchMutation>;
export type OneTimeSavedSearchMutationOptions = Apollo.BaseMutationOptions<OneTimeSavedSearchMutation, OneTimeSavedSearchMutationVariables>;
export const RemoveFavouriteListingDocument = gql`
    mutation RemoveFavouriteListing($listingId: ID!) {
  removeFavouriteListing(listingId: $listingId)
}
    `;
export type RemoveFavouriteListingMutationFn = Apollo.MutationFunction<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>;

/**
 * __useRemoveFavouriteListingMutation__
 *
 * To run a mutation, you first call `useRemoveFavouriteListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFavouriteListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFavouriteListingMutation, { data, loading, error }] = useRemoveFavouriteListingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useRemoveFavouriteListingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>(RemoveFavouriteListingDocument, options);
      }
export type RemoveFavouriteListingMutationHookResult = ReturnType<typeof useRemoveFavouriteListingMutation>;
export type RemoveFavouriteListingMutationResult = Apollo.MutationResult<RemoveFavouriteListingMutation>;
export type RemoveFavouriteListingMutationOptions = Apollo.BaseMutationOptions<RemoveFavouriteListingMutation, RemoveFavouriteListingMutationVariables>;